import { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { debounce, uniqueId } from 'lodash';
import { ChevronRight as ICON_CHEVRON_RIGHT, ChevronLeft as ICON_CHEVRON_LEFT, X as ICON_CLOSE } from 'react-feather';
import uniqueString from 'unique-string';
// STRIPE
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
const stripePromise = loadStripe(process.env.STRIPE_PUBLIC_KEY);
// redux
import { connect } from 'react-redux';
import { mapDispatchProps, mapStateToProps } from '../../store/store';
import { BRAND_BILLING_TYPES } from '../../store/brand/reducer';
// Core
import API from '../../api';
import { ROUTES } from '../../routes';
import { getLanguage, useLanguage } from '@languages/index';
import { BRAND_DTO_ENUMS } from 'api/repositories/brand/brand.constants';
import { GuidelineRuleDto } from 'api/repositories/guidelineRules/guidelineRules.types';
import BRAND from '../../constants/brand';
import { CAMPAIGN_UPDATE_FORM_TYPE } from 'constants/campaign';
import { COUNTRY_CD } from 'constants/country';
import { isGlovv, isKoreaService, isKyolook } from 'constants/domains/domains';
import GUIDELINE_RULES from 'constants/guidelineRules';
import { LOCALES } from 'constants/locales';
import { PAYMENT_PRODUCT_TYPE } from 'constants/payment';
import { getCurrencyMultiplier, makeMoneyText } from 'helpers/currency';
import HELPER_UI from 'helpers/ui';
import useInfiniteScroll from 'hooks/useInfiniteScroll';
// Components
import BottomGradient from 'components/bottomGradient';
import Button from 'components/button';
import CampaignApplicantItem from 'components/campaignApplicantItem';
import Checkbox from 'components/checkbox';
import LoadingText from 'components/loadingText';
import ModelCard, { TYPES } from 'components/modelCard';
import OverlayMatchRatingSetting from 'components/overlayMatchRatingSetting';
import Paginator from 'components/paginator';
import PostingCard from 'components/postingCard';
import OverlayBrandTaxInvoiceInfoForm, {
  OverlayBrandTaxInvoiceInfoFormResult,
} from 'components/overlayBrandTaxInvoiceInfoForm';
import RadioButton from 'components/radioButton';
// Children
import PaymentCreateAdditionalSeeding from '../payments/createAdditionalSeeding';
import CampaignExtendIndex from './extend';
import CampaignUpdateIndex from './update';
import { CampaignStatus } from '.';
import GuidelineRulesModal from './components/guidelineRulesModal/guidelineRulesModal';
import { isMobileDevice } from 'utils/isMobileDevice';
import { GetHiddenInfluencersResponse, HiddenInfluencersType } from 'api/repositories/campaign/campaign.types';
import ModalRequestRecruitingCampaignApplicationBrand from 'components/modalBrandRequestRecruitingCampaignApplication';
import { InfluencerMessageModal } from 'components/modelCard/InfluencerMessageModal';

interface HandleProductUserLikeParams {
  productId: number
  userId: number
  currentLikeId: number | null
  applicants: any[]
  setApplicants: (data: any[]) => void
  brandToken: string
}

const CampaignShow = (props: any) => {
  const isWholesale = props.brand.businessType === BRAND.BUSINESS_TYPE.WHOLESALE;

  const currentLocale = getLanguage();
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
    ...language.component.modelCard,
    ...language.pages.campaigns,
    ...language.guidelineTitles,
  };
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const TAB_VALUES = {
    POSTINGS: 'postings',
    APPLICANTS: 'applicants',
  };

  const totalPostingsCount = useRef(undefined);
  const [currentPostingPage, setCurrentPostingPage] = useState(1);

  const [filterIsNotRented, setFilterNotRentedBefore] = useState(false);
  const [filterIsFavorite, setFilterLiked] = useState(false);
  const [filterIsSuggested, setFilterSuggested] = useState(false);
  const [filterIsProductUserLiked, setFilterIsProductUserLiked] = useState(false);
  const [filterIsPreviouslySelected, setFilterIsPreviouslySelected] = useState(false);
  const [filterIsNewInfluencer, setFilterIsNewInfluencer] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const [tabs, setTabs] = useState<any>([]);
  const [selectedTab, setSelectedTab] = useState<any>();
  const [totalApplicantsCount, setTotalApplicantsCount] = useState(0);

  const updateQuantityCampaignPaymentKey = useRef(uniqueString());

  const [selectedOrder, setSelectedOrder] = useState<any>(
    props.brand.isCategoryBeauty
      ? {
          name: languageTexts.sort_order_applied_at,
          column: 'created_at',
          order: 'desc',
          value: 2,
        }
      : {
          name: languageTexts.show_text_86,
          column: 'connected_at',
          order: 'desc',
          value: 1,
          tooltip: languageTexts._show_text_87(),
          tooltipWidth: 360,
        },
  );

  const selectedRef = useRef<any>([]);
  const [selected, setSelectedState]: any = useState([]);
  const setSelected = (newSelected: any) => {
    const nextValue = typeof newSelected === 'function' ? newSelected(selectedRef.current) : newSelected;
    selectedRef.current = nextValue;
    setSelectedState(nextValue);
  };

  const [postings, setPostings] = useState<any>(undefined);
  const [postingPaginator, setPostingPaginator] = useState<any>();
  const [isPostingsEnded, setIsPostingsEnded] = useState(false);
  const [isPostingsFetching, setIsPostingsFetching] = useInfiniteScroll(() => {});

  /** 모델 목록: 뷰티  */

  /** 모델 목록: 뷰티 추천 모델 전용 */
  const [suggestedAndCommissionIncreasedApplicants, setSuggestedAndCommissionIncreasedApplicants] =
    useState<any>(undefined);
  const [suggestedAndCommissionNotIncreasedApplicants, setSuggestedAndCommissionNotIncreasedApplicants] =
    useState<any>(undefined);
  const [suggestedAndCommissionIncreasedApplicantsCount, setSuggestedAndCommissionIncreasedApplicantsCount] =
    useState<any>(undefined);
  const [suggestedAndCommissionNotIncreasedApplicantsCount, setSuggestedAndCommissionNotIncreasedApplicantsCount] =
    useState<any>(undefined);
  const [isSuggestedApplicantsFetching, setIsSuggestedApplicantsFetching] = useState(false);

  /** 모델 목록: Style & Category 적합 */
  const [currentModelPage, setCurrentModelPage] = useState(1);
  const [applicantPaginator, setApplicantPaginator] = useState<any>();
  const [applicants, setApplicants] = useState<any>(undefined);
  const [applicantsCount, setApplicantsCount] = useState<any>(undefined);
  const [isApplicantsEnded, setIsApplicantsEnded] = useState(false);
  const [isApplicantsFetching, setIsApplicantsFetching] = useInfiniteScroll(() => {}, true);

  /** 모델 목록: 부적합. Unfavorable Category */
  const [currentUnfavorableModelPage, setCurrentUnfavorableModelPage] = useState(1);
  const [unfavorableApplicantPaginator, setUnfavorableApplicantPaginator] = useState<any>();
  const [unfavorableApplicants, setUnfavorableApplicants] = useState<any>(undefined);
  const [isUnfavorableApplicantsEnded, setIsUnfavorableApplicantsEnded] = useState(false);
  const [isUnfavorableApplicantsFetching, setIsUnfavorableApplicantsFetching] = useInfiniteScroll(() => {}, true);

  /** 모델 숨겨진 인플루언서 */
  const [hiddenInfluencers, setHiddenInfluencers] = useState<GetHiddenInfluencersResponse['data'] | undefined>(undefined);

  // 모든 인플루언서
  const ALL_INFLUENCERS = useMemo(() => {
    return [
      ...(suggestedAndCommissionIncreasedApplicants || []),
      ...(suggestedAndCommissionNotIncreasedApplicants || []),
      ...(applicants || []),
      ...(unfavorableApplicants || []),
    ];
  }, [suggestedAndCommissionIncreasedApplicants,suggestedAndCommissionNotIncreasedApplicants,applicants,unfavorableApplicants]);




  // 가이드라인
  const [guidelines, setGuidelines] = useState<any>(undefined);

  const params = useParams();
  const campaignId = useRef(params.campaignId);
  const productId = useRef(params.productId);

  const campaign = useRef<any>(undefined);
  const product = useRef<any>(undefined);

  const [quantity, setQuantity] = useState(undefined);

  const matchSelectedCategoriesRef = useRef<any[]>([]);
  const matchBannedCategoriesRef = useRef<any[]>([]);
  const [matchBannedCategories, setMatchBannedCategoriesState] = useState<any[]>(matchBannedCategoriesRef.current);

  /****************************
   * Ref+State Functions
   ****************************/

  function setMatchBannedCategories(newMatchBannedCategories: any[]) {
    matchBannedCategoriesRef.current = newMatchBannedCategories;
    setMatchBannedCategoriesState(newMatchBannedCategories);
  }

  /****************************
   * Effect Hooks
   ****************************/

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    const isBeautyBrand = props.brand?.isCategoryBeauty;
    if (
      isBeautyBrand &&
      (suggestedAndCommissionNotIncreasedApplicants != undefined ||
        suggestedAndCommissionIncreasedApplicants != undefined)
    ) {
      fetchSuggestedApplicants({ refresh: true });
    }
    if (applicants != undefined) {
      fetchApplicants({
        refresh: true,
        isSuggested: isBeautyBrand ? false : undefined,
        hasTagAssignmentsSeedableProductCategoryBeauty:
          isBeautyBrand && campaign.current?.status < CampaignStatus.SELECTION_ENDED,
      });
    }
    if (unfavorableApplicants != undefined) {
      fetchUnfavorableApplicants({
        refresh: true,
        hasTagAssignmentsSeedableProductCategoryBeauty:
          props.brand.isCategoryBeauty && campaign.current?.status < CampaignStatus.SELECTION_ENDED,
      });
    }
  }, [filterIsNotRented, filterIsFavorite, filterIsProductUserLiked, filterIsPreviouslySelected, filterIsNewInfluencer, filterIsSuggested]);

  useEffect(() => {
    const isBeautyBrand = props.brand?.isCategoryBeauty;
    if (
      isBeautyBrand &&
      (suggestedAndCommissionNotIncreasedApplicants != undefined ||
        suggestedAndCommissionIncreasedApplicants != undefined)
    ) {
      fetchSuggestedApplicants({ refresh: true });
    }
    if (applicants != undefined) {
      fetchApplicants({
        refresh: true,
        isSuggested: isBeautyBrand ? false : undefined,
        hasTagAssignmentsSeedableProductCategoryBeauty:
          isBeautyBrand && campaign.current?.status < CampaignStatus.SELECTION_ENDED,
      });
    }
    if (unfavorableApplicants != undefined) {
      fetchUnfavorableApplicants({
        refresh: true,
        hasTagAssignmentsSeedableProductCategoryBeauty:
          props.brand.isCategoryBeauty && campaign.current?.status < CampaignStatus.SELECTION_ENDED,
      });
    }
  }, [selectedOrder]);

  const allApplicants = useMemo(() => {
    return [
      ...(suggestedAndCommissionNotIncreasedApplicants || []),
      ...(suggestedAndCommissionIncreasedApplicants || []),
      ...(applicants || []),
      ...(unfavorableApplicants || []),
    ];
  }, [
    suggestedAndCommissionNotIncreasedApplicants,
    suggestedAndCommissionIncreasedApplicants,
    applicants,
    unfavorableApplicants,
  ]);

  /****************************
   * API Functions
   ****************************/

  /*
   * Reusable handler for toggling product user like
   * Works with any applicant array (unfavorable, suggested, etc.)
   * 
   * Business Logic:
   * - Brand with specific product likes/unlikes user (influencer/model)
   * - Updates applicant array after successful API call
   */
   const handleProductUserLike = async ({
      productId,
      userId,
      currentLikeId,
      applicants,
      setApplicants,
      brandToken,
    }: HandleProductUserLikeParams) => {
      try {
        let response

        if (currentLikeId) {
          // Unlike: delete the record with brand token
          response = await API.ProductUserLike.delete(currentLikeId, brandToken)
        } else {
          // Like: create new record with brand token
          response = await API.ProductUserLike.store({
            brand_token: brandToken,
            product_id: productId,
            user_id: userId,
          })
        }

        // Update applicants array
        const updatedApplicants = applicants.map((item) =>
          item.userId === userId
            ? {
                ...item,
                productUserLikes: currentLikeId ? [] : [response?.data?.data],
              }
            : item,
        )

        setApplicants(updatedApplicants)
      } catch (error: any) {
        // console.error('Product user like error:', error?.response?.data?.message || error?.message || error)
      }
    }

  const fetch = async () => {
    await fetchCampaign();
    await fetchCampaignGuidelineRules();
    await fetchProduct();
    await fetchMatchRatings();
    await fetchAllApplicants({ refresh: true });
    await fetchHiddenInfluencers();
  };

  const fetchHiddenInfluencers = async () => {
    try {
    const response = await API.Campaign.getHiddenInfluencers({
          campaignId: campaignId.current as string,
          productId: productId.current as string,
          brandToken: props.auth.token as string,
      });
      setHiddenInfluencers(response?.data);
    } catch (error) {
      setHiddenInfluencers(undefined);
      console.error('fetchHiddenInfluencers error', error);
    }
  }

  const fetchAllApplicants = async (config: any) => {
    if (props.brand.isCategoryBeauty) {
      await Promise.all([
        fetchSuggestedApplicants(config),
        fetchApplicants({
          ...config,
          isSuggested: false,
          hasTagAssignmentsSeedableProductCategoryBeauty: campaign.current?.status < CampaignStatus.SELECTION_ENDED,
        }),
        fetchUnfavorableApplicants({
          ...config,
          hasTagAssignmentsSeedableProductCategoryBeauty: campaign.current?.status < CampaignStatus.SELECTION_ENDED,
        }),
      ]);
    } else {
      await Promise.all([fetchApplicants(config), fetchUnfavorableApplicants(config)]);
    }
  };

  const fetchSuggestedApplicants = async (config?) => {
    let params: any = {
      brandToken: props.auth.token,
      campaignId: campaignId.current,
      productId: productId.current,
      isRented: filterIsNotRented ? false : null,
      isPreviouslySelected: filterIsPreviouslySelected ? true : null, 
      isFavorite: filterIsFavorite ? true : null,
      isProductUserLiked: filterIsProductUserLiked ? true : null,
      isNewInfluencer: filterIsNewInfluencer ? true : null,
      isSuggested: true,
      isCommissionIncreased: false,
      orderColumn: selectedOrder ? selectedOrder.column : 'connected_at',
      orderValue: selectedOrder ? selectedOrder.order : 'desc',
      excludedBannedCategoryIds: matchBannedCategoriesRef.current.map((mc, i) => mc.id),
      withRentalPostingDue: true,
      page: 1,
      size: 10000, // 전체 노출
    };

    setIsSuggestedApplicantsFetching(true);
    if (config?.refresh === true) {
      if (suggestedAndCommissionIncreasedApplicants !== undefined)
        setSuggestedAndCommissionIncreasedApplicants(undefined);
      if (suggestedAndCommissionNotIncreasedApplicants !== undefined)
        setSuggestedAndCommissionNotIncreasedApplicants(undefined);
    }

    try {
      // const response = await API.CampaignApplicants.index(params);
      const response = await API.CampaignApplicants.index(params)
      const commissionIncreasedApplicantsIncoming =
        response.data.applicants?.filter((applicant) => applicant.isCommissionAmountIncreased) ?? [];
      const commissionNotIncreasedApplicantsIncoming =
        response.data.applicants?.filter((applicant) => !applicant.isCommissionAmountIncreased) ?? [];
      setSuggestedAndCommissionIncreasedApplicants((prev) => commissionIncreasedApplicantsIncoming);
      setSuggestedAndCommissionNotIncreasedApplicants((prev) => commissionNotIncreasedApplicantsIncoming);

      //// COUNTs
      // size:10000으로 사실상 전체 호출이라 paginator.total은 의미 없음,
      // API 요청 및 분기 최소화를 위해 클라이언트단에서 count를 계산
      // const totalCount = response.data.paginator?.total;
      const commissionIncreasedCountIncoming = commissionIncreasedApplicantsIncoming?.length;
      const commissionNotIncreasedCountIncoming = commissionNotIncreasedApplicantsIncoming?.length;
      setSuggestedAndCommissionIncreasedApplicantsCount((prev) => commissionIncreasedCountIncoming);
      setSuggestedAndCommissionNotIncreasedApplicantsCount((prev) => commissionNotIncreasedCountIncoming);
      setIsSuggestedApplicantsFetching(false);
    } catch (error) {
      props.showModal({ text: error.message });
    }
  };

  const fetchUnfavorableApplicants = async (config?) => {
    if (matchBannedCategoriesRef.current.length == 0) {
      setCurrentUnfavorableModelPage(1);
      setIsUnfavorableApplicantsFetching(false);
      setUnfavorableApplicants([]);
      setIsUnfavorableApplicantsEnded(true);
      setUnfavorableApplicantPaginator(undefined);
      return;
    }

    let targetPage = config?.page ? config.page : currentUnfavorableModelPage;
    if (config?.refresh) targetPage = 1;

    let params: any = {
      brandToken: props.auth.token,
      campaignId: campaignId.current,
      productId: productId.current,
      isRented: filterIsNotRented ? false : null,
      isPreviouslySelected: filterIsPreviouslySelected ? true : null, 
      isFavorite: filterIsFavorite ? true : null,
      isProductUserLiked: filterIsProductUserLiked ? true : null,
      isNewInfluencer: filterIsNewInfluencer ? true : null,
      isSuggested: filterIsSuggested ? true : null,
      orderColumn: selectedOrder ? selectedOrder.column : 'connected_at',
      orderValue: selectedOrder ? selectedOrder.order : 'desc',
      includedBannedCategoryIds: matchBannedCategoriesRef.current.map((ms, i) => ms.id),
      withRentalPostingDue: true,
      page: targetPage,
      size: 50,
    };
    
    setIsUnfavorableApplicantsFetching(true);
    if (config?.refresh === true && unfavorableApplicants !== undefined) setUnfavorableApplicants(undefined);

    try {
      // const response = await API.CampaignApplicants.index(params);
      const response = await API.CampaignApplicants.index(params)
      const _paginator = response.data.paginator;
      setUnfavorableApplicants(() => {
        return response.data.applicants;
      });

      setCurrentUnfavorableModelPage(targetPage);
      setIsUnfavorableApplicantsEnded(_paginator.currentPage == _paginator.lastPage);
      setUnfavorableApplicantPaginator(_paginator);
      setIsUnfavorableApplicantsFetching(false);
    } catch (error) {
      props.showModal({ text: error.message });
    }
  };

  const fetchApplicants = async (config?) => {
    let targetPage = config?.page ? config.page : currentModelPage;
    if (config?.refresh) targetPage = 1;

    let params: any = {
      brandToken: props.auth.token,
      campaignId: campaignId.current,
      productId: productId.current,
      isRented: filterIsNotRented ? false : null,
      isPreviouslySelected: filterIsPreviouslySelected ? true : null, 
      isFavorite: filterIsFavorite ? true : null,
      isProductUserLiked: filterIsProductUserLiked ? true : null,
      isNewInfluencer: filterIsNewInfluencer ? true : null,
      isSuggested: config?.isSuggested != null ? config.isSuggested : filterIsSuggested ? true : null,
      hasTagAssignmentsSeedableProductCategoryBeauty: config?.hasTagAssignmentsSeedableProductCategoryBeauty,
      isCommissionIncreased: config?.isCommissionIncreased,
      orderColumn: selectedOrder ? selectedOrder.column : 'connected_at',
      orderValue: selectedOrder ? selectedOrder.order : 'desc',
      excludedBannedCategoryIds: matchBannedCategoriesRef.current.map((mc, i) => mc.id),
      withRentalPostingDue: true,
      page: targetPage,
      size: 50,
    };

    setIsApplicantsFetching(true);
    if (config?.refresh === true && applicants !== undefined) setApplicants(undefined);

    try {
      // const response = await API.CampaignApplicants.index(params);
      const response = await API.CampaignApplicants.index(params)
      const _paginator = response.data.paginator;
      setApplicants(() => {
        return response.data.applicants;
      });
      setApplicantsCount((prev) => {
        return response.data.paginator?.total;
      });
      setCurrentModelPage(targetPage);
      setIsApplicantsEnded(_paginator.currentPage == _paginator.lastPage);
      setApplicantPaginator(_paginator);
      setIsApplicantsFetching(false);
    } catch (error) {
      props.showModal({ text: error.message });
    }
  };

  const fetchBrand = async () => {
    const response = await API.Auth.show({ brandToken: props.auth.token });
    props.setBrand(response.data.brand);
    return response.data.brand;
  };

  const fetchCampaign = async () => {
    return await API.Campaign.show({
      campaignId: campaignId.current,
      brandToken: props.auth.token,
      appends: ['seeding_pass_payment'],
    })
      .then((response) => {
        campaign.current = response.data.campaign;
      })
      .catch((error) => {
        console.error('fetchCampaign error', error);
      });
  };

  const fetchCampaignGuidelineRules = async () => {
    return await API.GuidelineRules.index({
      campaignId: campaignId.current,
    })
      .then((response) => {
        setGuidelines(response.data.rules);
      })
      .catch((error) => {
        console.error('fetchCampaignGuidelineRules error', error);
      });
  };

  const fetchProduct = async () => {
    return await API.Product.show({
      id: productId.current,
      brandToken: props.auth.token,
      with: ['product_master'],
    })
      .then((response) => {
        product.current = response.data.product;
        if (quantity == null) {
          setQuantity(product.current.qty);
        }
        setTotalApplicantsCount(response.data.product.applicantsCount);
        initTabs();
      })
      .catch((error) => {
        props.showModal({ text: error.message });
        history.back();
      });
  };

  const fetchPostings = async (config?) => {
    let targetPage = config?.page ? config.page : currentPostingPage;
    if (config?.refresh) targetPage = 1;

    let params = {
      brandToken: props.auth.token,
      brandId: props.brand.id,
      productId: productId.current,
      page: targetPage,
      size: 50,
      with: ['brand', 'downloadable_videos', 'user.suggestions', 'rental.guidelines'],
      append: ['validated_partnership_code'],
      derivedData: ['exposed_video_url'],
    };

    setIsPostingsFetching(true);
    setPostings([]);

    API.Post.index(params)
      .then((response: AxiosResponse) => {
        const _paginator = response.data.paginator;
        totalPostingsCount.current = response.data.count;

        setPostings(() => {
          return response.data.postings;
        });

        setIsPostingsEnded(_paginator.currentPage == _paginator.lastPage);
        setCurrentPostingPage(targetPage);
        setPostingPaginator(_paginator);
        setIsPostingsFetching(false);
      })
      .catch((error) => {
        props.showModal({ text: error.message });
      });
  };

  const fetchMatchRatings = async () => {
    try {
      const response = await API.MatchRating.index({
        brandToken: props.auth.token,
        brandId: props.brand.id,
        with: ['category'],
      });
      const newMatchSelectedCategories = [];
      const newMatchBannedCategories = [];
      for (const matchRating of response.data.matchRatings) {
        if (matchRating.rating == null || matchRating.rating == 0) {
          continue;
        }
        if (matchRating.categoryId != null && matchRating.category != null && matchRating.rating > 0) {
          matchRating.category['rating'] = matchRating.rating;
          newMatchSelectedCategories.push(matchRating.category);
          continue;
        }
        if (matchRating.categoryId != null && matchRating.category != null && matchRating.rating < 0) {
          matchRating.category['rating'] = matchRating.rating;
          newMatchBannedCategories.push(matchRating.category);
          continue;
        }
      }
      matchSelectedCategoriesRef.current = newMatchSelectedCategories;
      setMatchBannedCategories(newMatchBannedCategories);
    } catch (error) {
      props.showModal({ text: error.message });
    }
  };

  const updateQuantity = async (qty, campaignPaymentKey = undefined, displayResultModal = true) => {
    if (!campaign || !campaign.current) return null;
    if (!product || !product.current) return null;

    if (isNaN(parseInt(qty))) {
      props.showModal({ text: languageTexts.show_text_52 });
      return null;
    }

    const commissionAmount = campaign.current?.commissionPaymentPrice;

    try {
      let params = {
        brandToken: props.auth.token,
        campaignId: campaign.current.id,
        productId: product.current.id,
        qty: qty,
        commissionAmount: commissionAmount ?? undefined,
        campaignPaymentKey: campaignPaymentKey ?? undefined,
      } as any;

      const response = await API.Campaign.updateQuantity(params);

      await fetchProduct();
      if (quantity !== product.current.qty) {
        setQuantity(product.current.qty);
      }
      if (campaignPaymentKey != null) {
        updateQuantityCampaignPaymentKey.current = uniqueId();
      }
      if (displayResultModal == false) return false;
      props.showModal({ text: response.message });
    } catch (error) {
      props.showModal({
        text: error.message,
        confirm: () => {
          window.location.reload();
        },
      });
    }
  };

  const deleteProduct = async (productId) => {
    try {
      await API.Product.delete({
        type: 'PRODUCT',
        id: productId,
        brandToken: props.auth.token,
      });

      setTimeout(() => {
        props.showModal({
          text: languageTexts.create_delete_modal_success,
          confirm: () => {
            navigate(ROUTES.CAMPAIGN_INDEX.PATH);
          },
        });
      }, 400);
    } catch (error) {
      setTimeout(() => {
        props.showModal({
          text: error.message,
        });
      }, 400);
    }
  };

  /****************************
   * Handler Functions
   ****************************/

  const handleSelect = (application: any) => {
    const { current: currentCampaign } = campaign;
    const { current: currentProduct } = product;

    if (!getSelectableStatus(currentCampaign, currentProduct)) {
      return false;
    }

    const isCurrentlySelected = selected.includes(application.userId);

    if (isCurrentlySelected) {
      setSelected(selected.filter((item) => item !== application.userId));
    } else {
      // if (selected.length + 1 > currentProduct.qty) {
      //   props.showModal({
      //     text: languageTexts._select_text_2(currentProduct.qty),
      //   })
      //   return false
      // }

      setSelected([...selected, application.userId]);
    }
  };

  const handleAdditionalPayment = (onSuccess?: () => void) => {
    const hasCommissionIncreasedApplicants = getIncreasedCommissionApplicants(selectedRef.current);
    const hasExceededQuantity = selectedRef.current.length > product.current.qty;

    if (selectedRef.current.length < product.current.qty) {
      props.showModal({
        hideCloseButton: true,
        title: languageTexts.show_text_101,
        text: languageTexts.show_text_102,
      });
      return false;
    }

    if (hasCommissionIncreasedApplicants?.length || hasExceededQuantity) {
      showAdditionalPaymentRequiredModal({
        currentProductQuantity: product.current.qty,
        targetProductQuantity: selectedRef.current.length,
        commissionIncreasedApplicants: hasCommissionIncreasedApplicants,
        onSuccess: () => {
          onSuccess();
        },
      });
      return true;
    }

    return false;
  };

  const handleUpdateQuantity = (quantity) => {
    const isKyolookSeedingPassActive = BRAND.isKyolookSeedingPassActive(props.brand);
    const isSeedingFreeUser = props.brand.priceSeedingPass == 0;
    const hasSeedingPass = props.brand.remainSeedingPass;
    const hasCommissions = campaign.current?.commissionAmount != null && campaign.current?.commissionAmount > 0;
    const hasInspectionFee = campaign.current?.inspectionSubmitDueDt != null;
    const canProcessWithoutPayment =
      !hasCommissions && !hasInspectionFee && (isKyolookSeedingPassActive || isSeedingFreeUser || hasSeedingPass);

    if (canProcessWithoutPayment) {
      handlePaymentComplete({
        quantityUpdateRequired: {
          run: true,
          quantity: quantity,
          campaignPaymentKey: undefined,
        },
        confirmSelectionRequired: { run: false },
      });
      return;
    }

    //// ELSE
    if (quantity < product.current.qty) {
      props.showModal({
        hideCloseButton: true,
        title: languageTexts.show_text_101,
        text: languageTexts.show_text_102,
      });
      return;
    } else if (quantity > product.current.qty) {
      showAdditionalPaymentRequiredModal({
        currentProductQuantity: product.current.qty,
        targetProductQuantity: quantity,
        onSuccess: () => {
          handlePaymentComplete({
            quantityUpdateRequired: {
              run: true,
              quantity: quantity,
              campaignPaymentKey: updateQuantityCampaignPaymentKey.current,
            },
            confirmSelectionRequired: { run: false },
          });
        },
      });
      return;
    }
  };

  /************************************
   * UpdateQuantity Payment Related
   ************************************/
  const getApplicantsFromUserIds = (userIds: number[]) => {
    const allApplicants = [
      ...(suggestedAndCommissionIncreasedApplicants ?? []),
      ...(suggestedAndCommissionNotIncreasedApplicants ?? []),
      ...(applicants ?? []),
      ...(unfavorableApplicants ?? []),
    ];
    return allApplicants.filter((applicant) => userIds.includes(applicant.userId));
  };

  const getIncreasedCommissionApplicants = (selectedApplicantIds: number[]) => {
    if (!campaign.current?.commissionAmount) return [];

    const selectedApplicants = getApplicantsFromUserIds(selectedApplicantIds);
    return selectedApplicants.filter((applicant) => {
      return applicant.commissionAmount > campaign.current.commissionAmount;
    });
  };

  const proceedPayment = async (params: {
    targetProductType: string;
    additionalProductQuantity: number;
    targetProductQuantity: number;
    commissionIncreasedApplicants?: any[];
    onSuccess?: () => void;
  }) => {
    if (campaign.current == null || product.current == null) return false;

    let amount = undefined;
    let price = undefined;
    let commissionPrice = campaign.current?.commissionPaymentPrice;
    let priceTotal = undefined;

    // handleChange(`paymentProductType`, targetProductType)

    await fetchBrand();
    props.closeOverlays();

    const isSeedingFreeUser = props.brand.priceSeedingPass == 0;
    const hasSeedingPass = props.brand.remainSeedingPass;

    switch (params.targetProductType) {
      case PAYMENT_PRODUCT_TYPE.SEEDING:
        const isKyolookSeedingPassActive = BRAND.isKyolookSeedingPassActive(props.brand);
        const isSeedingPass = isKyolookSeedingPassActive || isSeedingFreeUser || hasSeedingPass;
        amount = 0;
        amount = amount + params.additionalProductQuantity;
        price = isSeedingPass ? 0 : props.brand.priceSeeding;
        priceTotal = price * amount + (commissionPrice ?? 0) * amount;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS:
        amount = 0;
        amount = amount + params.additionalProductQuantity;
        price = props.brand.priceSeedingPass;
        priceTotal = price + (commissionPrice ?? 0) * amount;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_RECOVER:
        amount = 1;
        price = props.brand.priceSeedingPass;
        priceTotal = null;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE:
        amount = 0;
        amount = amount + params.additionalProductQuantity;
        price = props.brand.priceSeeding;
        priceTotal = price * amount + (commissionPrice ?? 0) * amount;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY:
        amount = 0;
        amount = amount + params.additionalProductQuantity;
        price = props.brand.priceSeedingPass;
        priceTotal = price + (commissionPrice ?? 0) * amount;
        break;
    }

    const campaignEndsAt = campaign.current.postingEndsAt ? dayjs(campaign.current.postingEndsAt) : null;
    const seedingPassEndsAt = props.brand.activeSeedingPassEndsAt ? dayjs(props.brand.activeSeedingPassEndsAt) : null;
    const isSeedingPassActive =
      (campaignEndsAt &&
        seedingPassEndsAt &&
        (seedingPassEndsAt.isSame(campaignEndsAt) || seedingPassEndsAt.isAfter(campaignEndsAt))) ||
      props.brand?.isSeedingPassAutoPurchaseEnabled;

    const handlePayment = debounce(async () => {
      const isFreeBrand = props.brand.billingType == BRAND_BILLING_TYPES.FREE;
      const hasSeedingPassAutopurchaseEnabled =
        props.brand.hasSeedingPass && props.brand.isSeedingPassAutoPurchaseEnabled;
      const hasActiveSeedingPass = props.brand.hasSeedingPass && isSeedingPassActive;
      const hasCommissions = campaign.current?.commissionAmount != null && campaign.current?.commissionAmount > 0;
      const hasCommissionIncreasedApplicants =
        params.commissionIncreasedApplicants && params.commissionIncreasedApplicants.length > 0;
      const hasInspectionFee = campaign.current?.inspectionSubmitDueDt != null;

      if (
        props.brand.isCategoryFashion ||
        props.brand.isCategoryFnb ||
        props.brand.isCategoryHotel ||
        props.brand.isCategoryEtc
      ) {
        const canProcessWithoutPayment =
          !hasCommissions &&
          !hasInspectionFee &&
          (hasSeedingPassAutopurchaseEnabled || hasActiveSeedingPass || isFreeBrand);
        if (canProcessWithoutPayment) {
          props.onSuccess?.();
          return;
        }
      } else if (props.brand.isCategoryBeauty) {
        const canProcessWithoutPayment = !hasCommissions && !hasInspectionFee && !hasCommissionIncreasedApplicants;
        if (canProcessWithoutPayment) {
          props.onSuccess?.();
          return;
        }
      }

      let inspectionFee = null;
      if (campaign.current.inspectionSubmitDueDt != null) {
        const currencyMultiplier = getCurrencyMultiplier(props.brand.currency);
        inspectionFee =
          parseInt(
            props.brand?.priceInspection != null ? props.brand.priceInspection : props.settings?.priceInspection ?? 0,
          ) * currencyMultiplier;
        priceTotal += inspectionFee * amount;
      }

      // 현금 결제 브랜드의 경우 세금계산서 정보 입력
      let cashCampaignPaymentData = null;

      const currentBrand = await fetchBrand();
      if (isKoreaService() && currentBrand.billingType === BRAND_DTO_ENUMS.BILLING_TYPE.FREE) {
        const brandTaxInvoiceInfoFormResult = await new Promise<OverlayBrandTaxInvoiceInfoFormResult>(
          (resolve, reject) => {
            props.showOverlays({
              content: () => <OverlayBrandTaxInvoiceInfoForm onComplete={(result) => resolve(result)} />,
            });
          },
        );
        if (!brandTaxInvoiceInfoFormResult.isSubmitted) {
          return;
        }
        cashCampaignPaymentData = brandTaxInvoiceInfoFormResult.data.campaignPayment;
      }

      showPaymentModal({
        targetProductType: params.targetProductType,
        amount,
        price,
        commissionPrice,
        inspectionFee,
        priceTotal,
        commissionIncreasedApplicants: params.commissionIncreasedApplicants,
        targetProductQuantity: params.targetProductQuantity,
        cashCampaignPaymentData: cashCampaignPaymentData as Pick<
          OverlayBrandTaxInvoiceInfoFormResult['data']['campaignPayment'],
          keyof OverlayBrandTaxInvoiceInfoFormResult['data']['campaignPayment']
        > | null,
        onSuccess: () => {
          params.onSuccess();
        },
      });
    }, 400);

    handlePayment();
  };

  const showPaymentOptions = (params: {
    additionalProductQuantity: number;
    targetProductQuantity: number;
    commissionIncreasedApplicants?: any[];
    onSuccess?: () => void;
  }) => {
    const campaignEndsAt = campaign.current.postingEndsAt ? dayjs(campaign.current.postingEndsAt) : null;
    const seedingPassEndsAt = props.brand.activeSeedingPassEndsAt ? dayjs(props.brand.activeSeedingPassEndsAt) : null;

    const isSeedingPassActive =
      (campaignEndsAt && seedingPassEndsAt && seedingPassEndsAt.isAfter(campaignEndsAt)) ||
      props.brand?.isSeedingPassAutoPurchaseEnabled;

    debounce(() => {
      props.showOverlays({
        className: 'w-full md:min-w-[640px] justify-center',
        content: () => {
          return (
            <div className="p-10 bg-white rounded-2xl">
              <div className="flex flex-col">
                <div className="flex flex-col">
                  <div className="flex flex-row w-full justify-between mb-6">
                    <div className="flex flex-col gap-4">
                      <span className="text-lg font-semibold md:text-2xl md:font-bold text-center md:text-start">
                        {languageTexts.pay}
                      </span>

                      {isSeedingPassActive == false && seedingPassEndsAt ? (
                        <span className="text-base tracking-tighter">
                          {languageTexts._createPaymentText1(seedingPassEndsAt.format(languageTexts.date_format))}
                        </span>
                      ) : (
                        <span className="font-bold text-lg tracking-tighter">
                          {languageTexts._createPaymentText2(
                            props.settings.durationSeedingPass,
                            props.brand.priceSeedingPass,
                            props.settings.currencyText,
                          )}
                        </span>
                      )}
                    </div>
                    <div
                      className=""
                      onClick={() => {
                        props.closeOverlays();
                      }}
                    >
                      <ICON_CLOSE />
                    </div>
                  </div>

                  <div className="flex flex-col my-3">
                    <div className="w-full flex flex-col">
                      <Button
                        className={'px-3 py-2 text-center rounded-lg'}
                        buttonColor={'#BF664A'}
                        text={languageTexts._createPaymentUnlimitedPrice(
                          props.settings.durationSeedingPass,
                          props.brand.priceSeedingPass,
                          props.settings.currencyText,
                        )}
                        justify={'center'}
                        textColor={'white'}
                        borderColor={'transparent'}
                        textClassName={'font-bold text-xl tracking-tighter text-white'}
                      />
                    </div>

                    <div className="flex flex-col justify-center mx-auto w-full bg-[#FFF7F7]">
                      <span className="font-bold text-xl text-center tracking-tighter py-4 mt-[12px]">
                        {languageTexts._create_payment_text21(props.settings.currencyText)}
                      </span>

                      {props.brand.isSeedingPassWelcomeBonusEnabled == true &&
                      props.brand.hasExperiencedSeedingPass == false ? (
                        <span className="font-bold text-xl text-center tracking-tighter">
                          {languageTexts.create_payment_text22}
                        </span>
                      ) : null}

                      <div className="opacity-50 text-black text-sm font-normal text-center mx-auto pb-7">
                        {languageTexts._create_payment_text23(props.settings.durationSeedingPass)}
                        <br />
                        {languageTexts.create_payment_text24}
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col gap-4">
                    <Button
                      text={languageTexts.create_payment_button_1}
                      buttonColor={'black'}
                      textColor={'white'}
                      justify={'center'}
                      onClick={async () => {
                        let productType = PAYMENT_PRODUCT_TYPE.SEEDING_PASS;

                        if (
                          props.brand.hasSeedingPass &&
                          !props.brand.isSeedingPassAutoPurchaseEnabled &&
                          isSeedingPassActive == false
                        ) {
                          productType = PAYMENT_PRODUCT_TYPE.SEEDING_PASS;
                        }
                        await fetchProduct();
                        proceedPayment({
                          targetProductType: productType,
                          additionalProductQuantity: params.additionalProductQuantity,
                          targetProductQuantity: params.targetProductQuantity,
                          onSuccess: params.onSuccess,
                        });
                      }}
                    />

                    {/* @note 250409 패션 건당 결제 비활성화 */}
                    {process.env.LOCALE == LOCALES.KO && !props.brand.isCategoryFashion ? (
                      <div className="flex flex-col gap-3">
                        <Button
                          text={languageTexts.create_payment_button_2}
                          buttonColor={'white'}
                          bordered
                          borderColor={'black'}
                          textColor={'black'}
                          justify={'center'}
                          onClick={async () => {
                            await fetchProduct();
                            proceedPayment({
                              targetProductType: PAYMENT_PRODUCT_TYPE.SEEDING,
                              additionalProductQuantity: params.additionalProductQuantity,
                              targetProductQuantity: params.targetProductQuantity,
                              onSuccess: params.onSuccess,
                            });
                          }}
                        />

                        <div className="flex flex-col items-center">
                          <span className="text-sm tracking-tighter opacity-50">
                            {languageTexts._create_payment_text31(props.settings.durationSeedingPass)}
                          </span>

                          <span className="text-sm tracking-tighter opacity-50">
                            {languageTexts.create_payment_text32}
                          </span>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          );
        },
      });
    }, 400)();
  };

  const showAdditionalPaymentSummary = (params: {
    additionalProductQuantity: number;
    targetProductQuantity: number;
    commissionIncreasedApplicants?: any[];
    onSuccess?: () => void;
  }) => {
    props.closeOverlays();

    const isSeedingPassActive = checkSeedingPassActive();
    const isKyolookSeedingPassActive = BRAND.isKyolookSeedingPassActive(props.brand);
    const { hasCommissions, hasInspectionFee, hasCommissionIncreasedApplicants } = checkAdditionalFees();

    if (canSkipPayment(isKyolookSeedingPassActive, isSeedingPassActive, hasCommissionIncreasedApplicants)) {
      handleSkipPaymentCase(params, hasCommissions, hasInspectionFee, hasCommissionIncreasedApplicants);
    } else {
      handlePaymentCase(params);
    }
  };

  const checkSeedingPassActive = () => {
    const campaignEndsAt = campaign.current?.postingEndsAt ? dayjs(campaign.current.postingEndsAt) : null;
    const seedingPassEndsAt = props.brand?.activeSeedingPassEndsAt ? dayjs(props.brand.activeSeedingPassEndsAt) : null;

    return (
      (campaignEndsAt && seedingPassEndsAt && seedingPassEndsAt.isAfter(campaignEndsAt)) ||
      props.brand?.isSeedingPassAutoPurchaseEnabled
    );
  };

  const checkAdditionalFees = () => ({
    hasCommissions: campaign.current?.commissionAmount != null && campaign.current?.commissionAmount > 0,
    hasInspectionFee: campaign.current?.inspectionSubmitDueDt != null,
    hasCommissionIncreasedApplicants: getIncreasedCommissionApplicants(selectedRef.current).length > 0,
  });

  const canSkipPayment = (
    isKyolookSeedingPassActive: boolean,
    isSeedingPassActive: boolean,
    hasCommissionIncreasedApplicants: boolean,
  ) => {
    if (
      props.brand.isCategoryFashion ||
      props.brand.isCategoryFnb ||
      props.brand.isCategoryHotel ||
      props.brand.isCategoryEtc
    ) {
      return (
        isKyolookSeedingPassActive ||
        (props.brand.hasSeedingPass && props.brand.isSeedingPassAutoPurchaseEnabled) ||
        (props.brand.hasSeedingPass && isSeedingPassActive) ||
        props.brand.billingType == BRAND_BILLING_TYPES.FREE ||
        props.brand.priceSeedingPass == 0
      );
    } else if (props.brand.isCategoryBeauty) {
      return hasCommissionIncreasedApplicants == false ? true : false;
    }
  };

  const handleSkipPaymentCase = (
    params: any,
    hasCommissions: boolean,
    hasInspectionFee: boolean,
    hasCommissionIncreasedApplicants: boolean,
  ) => {
    if (props.brand.isCategoryBeauty) {
      const canProcessWithoutPayment = !hasCommissions && !hasInspectionFee && !hasCommissionIncreasedApplicants;
      canProcessWithoutPayment ? params.onSuccess() : handleBeautyCategory(params);
    } else {
      const canProcessWithoutPayment = !hasCommissions && !hasInspectionFee && !hasCommissionIncreasedApplicants;
      canProcessWithoutPayment ? params.onSuccess() : handleOtherCategories(params, PAYMENT_PRODUCT_TYPE.SEEDING);
    }
  };

  const handlePaymentCase = async (params: any) => {
    if (props.brand.isCategoryBeauty) {
      handleBeautyCategory(params);
    } else {
      showPaymentOptions(params);
    }
  };

  const handleBeautyCategory = (params: any) => {
    fetchProduct();
    proceedPayment({
      targetProductType: PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE,
      additionalProductQuantity: params.additionalProductQuantity,
      targetProductQuantity: params.targetProductQuantity,
      commissionIncreasedApplicants: params.commissionIncreasedApplicants,
      onSuccess: params.onSuccess,
    });
  };

  const handleOtherCategories = (params: any, productType: string) => {
    fetchProduct();
    proceedPayment({
      targetProductType: productType,
      additionalProductQuantity: params.additionalProductQuantity,
      targetProductQuantity: params.targetProductQuantity,
      commissionIncreasedApplicants: params.commissionIncreasedApplicants,
      onSuccess: params.onSuccess,
    });
  };

  const handlePaymentComplete = async ({
    quantityUpdateRequired,
    confirmSelectionRequired,
  }: {
    quantityUpdateRequired: {
      run: boolean;
      quantity?: number;
      campaignPaymentKey?: string;
    };
    confirmSelectionRequired: { run: boolean };
  }) => {
    if (quantityUpdateRequired?.run) {
      if (quantityUpdateRequired?.quantity != product.current.qty) {
        await updateQuantity(
          quantityUpdateRequired?.quantity,
          quantityUpdateRequired?.campaignPaymentKey,
          confirmSelectionRequired?.run ? false : true,
        );
      }
    }
    if (confirmSelectionRequired?.run) {
      await confirmSelection();
    }

    fetchBrand();
  };

  const showPaymentModal = (config: {
    targetProductType: string;
    amount: number;
    price: number;
    commissionPrice: number | null;
    inspectionFee: number | null;
    priceTotal: number;
    commissionIncreasedApplicants: any[];
    targetProductQuantity: number;
    cashCampaignPaymentData?: Pick<
      OverlayBrandTaxInvoiceInfoFormResult['data']['campaignPayment'],
      keyof OverlayBrandTaxInvoiceInfoFormResult['data']['campaignPayment']
    > | null;
    onSuccess?: () => void;
  }) => {
    props.showOverlays({
      content: () => {
        return (
          <Elements stripe={stripePromise}>
            <PaymentCreateAdditionalSeeding
              temporaryKey={updateQuantityCampaignPaymentKey.current}
              itemType={config.targetProductType}
              amount={config.amount}
              price={config.price}
              commissionPrice={config.commissionPrice}
              inspectionFee={config.inspectionFee}
              priceTotal={config.priceTotal}
              commissionIncreasedApplicants={config.commissionIncreasedApplicants}
              cashCampaignPaymentData={config.cashCampaignPaymentData}
              campaignData={campaign.current}
              productData={product.current}
              onSuccess={async () => {
                await config.onSuccess();
              }}
            />
          </Elements>
        );
      },
    });
  };

  /****************************
   * Render Functions
   ****************************/

  const initTabs = () => {
    const applicantsTabTitle = product.current.selectedAt ? languageTexts.show_text_5 : languageTexts.show_text_6;

    const initOptions = [
      { name: `${applicantsTabTitle}`, value: TAB_VALUES.APPLICANTS },
      { name: languageTexts.posting, value: TAB_VALUES.POSTINGS },
    ];
    setTabs([ ...initOptions ]);
    if (selectedTab == null && searchParams.get('tab') === TAB_VALUES.POSTINGS) {
      setSelectedTab({ ...initOptions[1] });
      fetchPostings({ refresh: true });
    } else {
      setSelectedTab({ ...initOptions[0] });
    }
  };

  const getSelectableStatus = (currentCampaign: any, currentProduct: any) => {
    if (currentProduct?.selectedAt != null) {
      return false;
    }

    let selectableCampaignStatus = [];
    switch (currentCampaign.brandBusinessType) {
      case BRAND.BUSINESS_TYPE.NORMAL:
        selectableCampaignStatus = [CampaignStatus.SELECTION_STARTED];
        break;

      case BRAND.BUSINESS_TYPE.WHOLESALE:
        selectableCampaignStatus = [CampaignStatus.RECRUIT_STARTED, CampaignStatus.SELECTION_STARTED];
        break;

      default:
        selectableCampaignStatus = [];
    }
    return selectableCampaignStatus.includes(currentCampaign.status);
  };

  const renderBreadcrumbs = () => {
    return (
      <div className="flex flex-col py-5">
        <div
          className="flex flex-row items-center gap-2 opacity-50 cursor-pointer"
          onClick={() => {
            navigate(-1);
          }}
        >
          <div>
            <ICON_CHEVRON_LEFT size={24} />
          </div>
          <div>
            <span className="text-sm font-bold tracking-tighter">{languageTexts.show_text_7}</span>
          </div>
        </div>
      </div>
    );
  };

  const showCampaignUpdateModal = useCallback(() => {
    props.showModal({
      content: () => {
        return (
          <CampaignUpdateIndex
            campaignData={campaign.current}
            productId={product.current.id}
            onUpdate={async () => {
              await fetchCampaign();
              await fetchProduct();
              await fetchAllApplicants({ refresh: true });
            }}
          />
        );
      },
    });
  }, [campaign, product]);

  const renderProductQuantity = () => {
    if (
      quantity == null ||
      campaign.current.status >= CampaignStatus.SELECTION_ENDED ||
      product.current.selectedAt != null
    ) {
      return null;
    }

    return (
      <div className="md:mt-1 flex flex-row items-center gap-[20px]" style={{ flex: '0 0 auto' }}>
        <div>{languageTexts.show_text_100}</div>
        <div className="flex flex-row items-center gap-[12px]">
          <div
            className={clsx([
              'w-[24px] h-[24px] flex justify-center items-center border border-[#E8E8E8] rounded-[3px] cursor-pointer select-none',
              quantity === 1 && 'text-[#C8C8C8]',
            ])}
            onClick={(e) => {
              setQuantity(Math.max(1, quantity - 1));
            }}
          >
            {`-`}
          </div>
          <div className="font-bold">{languageTexts._num_of_person(quantity)}</div>
          <div
            className="w-[24px] h-[24px] flex justify-center items-center border border-[#E8E8E8] rounded-[3px] cursor-pointer select-none"
            onClick={(e) => {
              setQuantity(quantity + 1);
            }}
          >
            {`+`}
          </div>
          {quantity != product.current.qty && (
            <div className="flex flex-row items-center gap-[12px]">
              <div
                className="px-[6px] h-[24px] border bg-[#000] border-[#000] rounded-[3px] text-[14px] text-[#FFF] cursor-pointer select-none"
                onClick={(e) => {
                  handleUpdateQuantity(quantity);
                }}
              >
                {languageTexts.change}
              </div>
              <div
                className="px-[6px] h-[24px] border border-[#E8E8E8] rounded-[3px] text-[14px] cursor-pointer select-none"
                onClick={(e) => {
                  setQuantity(product.current.qty);
                }}
              >
                {languageTexts.cancel}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderCampaignProductHeader = () => {
    if (!campaign || !campaign.current) return null;
    if (!product || !product.current) return null;

    const renderTopButtons = () => {
      const isRecruitBeforeStart = dayjs().isBefore(campaign.current.recruitStartsAt);

      const isCreatedWithSeedingPass = campaign.current?.seedingPassPayment != null;
      const isServiceOnlyCampaign =
        campaign.current?.commissionAmount == null && campaign.current?.inspectionSubmitDueDt == null;
      const isMaster = props.auth.isMaster && !isRecruitBeforeStart;

      return (
        <div className="flex flex-col justify-center gap-[12px] w-full md:w-auto">
          <div className="flex flex-row gap-[12px]">
            {/* 캠페인 수정 버튼 */}
            {(isMaster || isRecruitBeforeStart) && (
                <Button
                  className="flex justify-center md:min-w-[180px] px-6 py-2"
                  text={languageTexts.show_text_10}
                  textColor="BLACK"
                  textClassName="font-bold text-sm tracking-tighter text-center"
                  buttonColor={`${isMaster ? '#FFAAAA' : 'WHITE'}`}
                  borderColor="BLACK"
                  onClick={() =>
                    navigate({
                      pathname: ROUTES.CAMPAIGN_UPDATE.SHOW(campaign.current.id),
                      search: `?formType=${
                        isMaster ? CAMPAIGN_UPDATE_FORM_TYPE.MASTER : CAMPAIGN_UPDATE_FORM_TYPE.NORMAL
                      }`,
                    })
                  }
                />
              )}

            {/* 가이드라인 보기 버튼 */}
            {campaign.current?.outputType != null && guidelines != null && (
              <Button
                className="flex justify-center md:min-w-[180px] px-6 py-2"
                text={languageTexts.show_text_68}
                textColor="BLACK"
                textClassName="font-bold text-sm tracking-tighter text-center"
                buttonColor="WHITE"
                borderColor="BLACK"
                onClick={() => {
                  let containerStyle =
                    'flex flex-col w-full px-5 py-5 bg-white overflow-scroll max-w-[480px]' +
                    (props.preferences.isMobile ? ' h-full' : ' rounded-2xl');

                  props.showOverlays({
                    className: containerStyle,
                    content: () => <GuidelineRulesModal productId={product.current.id} />,
                  });
                }}
              />
            )}

            {/* 캠페인 삭제 버튼 */}
            {
              // isRecruitBeforeStart && // 25.06.11 DEPRECATED 모델 모집종료 이후에 원하는 모델 없어서 삭제요청하는 경우가 대부분이어서요
              isCreatedWithSeedingPass && isServiceOnlyCampaign && (
                <Button
                  className="flex justify-center md:min-w-[180px] px-6 py-2"
                  text={languageTexts.delete2}
                  textColor="BLACK"
                  textClassName="font-bold text-sm tracking-tighter text-center"
                  buttonColor="WHITE"
                  borderColor="BLACK"
                  onClick={() => {
                    props.showModal({
                      hideCloseButton: true,
                      isCompact: true,
                      title: languageTexts.delete2,
                      text: languageTexts.show_text_108,
                      confirm: () => {
                        deleteProduct(product.current.id);
                      },
                      cancel: () => {
                        // CANCEL 버튼 표기용
                      },
                    });
                  }}
                />
              )
            }
          </div>
          {isRecruitBeforeStart && !(isCreatedWithSeedingPass && isServiceOnlyCampaign) && (
            <p className="text-[14px] text-[#999999] text-right">{languageTexts.show_text_11}</p>
          )}
        </div>
      );
    };

    const renderMobileHeader = () => {
      return (
        <>
          <div className="flex flex-col">
            <div className="flex flex-row gap-2">{renderTopButtons()}</div>

            <div className="flex flex-row gap-4 mt-10">
              <div className="shrink-0 w-[72px] h-[72px]">
                <img className="w-full h-full md:h-full object-cover" src={product.current.thumbnailUrl} />
              </div>
              <div className="flex flex-col gap-1 justify-center tracking-tighter">
                {renderCommissionTag()}
                <p className="text-sm">{`${campaign.current.statusDesc}`}</p>
                <p className="text-xl font-bold">
                  {`${HELPER_UI.makeProductName(product.current.name, guidelines, campaign.current)}`}
                </p>
                <p className="text-base">{`${product.current.colorName} / ${
                  product.current.sizeName
                } / ${languageTexts._amount(product.current.qty)}`}</p>
                {renderProductQuantity()}
              </div>
            </div>

            <div className="flex flex-row mt-3 mb-8">
              <span className="text-sm tracking-tighter opacity-50">{campaign.current.description}</span>
            </div>
          </div>
        </>
      );
    };

    const renderCommissionTag = () => {
      const commissionPrice = campaign.current?.commissionPaymentPrice ?? 0; // 브랜드 원고료 결제금액
      return commissionPrice > 0 ? (
        // <span className="text-sm tracking-tighter truncate text-[#FF0099]">
        <span className="text-sm tracking-tighter truncate text-transparent bg-clip-text bg-gradient-to-r from-[#FA7035] to-[#FF0099]">
          {`${languageTexts.campaign_with_commissions}` +
            ` (${makeMoneyText(
              commissionPrice,
              10000,
              (moneyText) => languageTexts._price(moneyText, props.settings.currencyText),
              (moneyText) => languageTexts._price_10000(moneyText, props.settings.currencyText),
            )})`}
        </span>
      ) : null;
    };

    return (
      <>
        <div className="flex flex-col">
          {!props.preferences.isMobile && (
            <>
              <div className="flex flex-row w-full justify-between mt-[30px]">
                <div className="flex flex-col gap-2">
                  <span className="text-xs font-bold tracking-tighter">{`${campaign.current.statusDesc}`}</span>
                  {renderCommissionTag()}
                  <span className="text-xl font-bold tracking-tighter">
                    {`${HELPER_UI.makeProductName(product.current.name, guidelines, campaign.current)}`}
                  </span>

                  {product.current?.productMaster?.subItem && (
                    <span className="text-xs tracking-tighter">
                      {`${languageTexts.sub_item}: ${product.current.productMaster.subItem}`}
                    </span>
                  )}
                </div>
                <div className="w-full flex flex-1"></div>
              </div>
              <div className="mt-1 mb-3 flex flex-col lg:flex-row lg:justify-between gap-3">
                <div className="flex flex-col">
                  <div className="flex flex-row gap-1">
                    <span className="text-base tracking-tighter">{`${product.current.colorName}`}</span>
                    {props.brand.isCategoryFashion ? (
                      <>
                        <span className="text-base tracking-tighter">{` / `}</span>
                        <span className="text-base tracking-tighter">{`${product.current.sizeName}`}</span>
                      </>
                    ) : null}
                    <span className="text-base tracking-tighter">{` / `}</span>
                    <span className="text-base tracking-tighter">
                      {`${languageTexts._amount(product.current.qty)}`}
                    </span>
                  </div>
                  {renderProductQuantity()}
                </div>
                {renderTopButtons()}
              </div>

              <div className="flex flex-row mt-2 mb-8">
                <span className="text-sm tracking-tighter opacity-50">{campaign.current.description}</span>
              </div>
            </>
          )}
          {props.preferences.isMobile && renderMobileHeader()}
        </div>
        <div className="flex flex-row mb-10 gap-3">
          {!props.preferences.isMobile && (
            <div className="flex flex-col">
              <img className="w-full h-full md:w-[160px] md:h-full object-contain" src={product.current.thumbnailUrl} />
            </div>
          )}
          <div className="flex flex-col">
            <div className="flex flex-col w-full gap-3 md:gap-3 md:flex-row md:justify-between">
              <div className="flex flex-col min-w-[200px] gap-5">
                <div className="flex flex-col gap-1">
                  <span className="text-xs tracking-tighter font-bold">{languageTexts.show_text_20}</span>
                  <span className="text-sm tracking-tighter opacity-50">{`${campaign.current.recruitStartsAt} ~ ${campaign.current.recruitEndsAt}`}</span>
                </div>

                <div className="flex flex-col gap-1">
                  <span className="text-xs tracking-tighter font-bold">{languageTexts.show_text_21}</span>
                  <span className="text-sm tracking-tighter opacity-50">{`${campaign.current.selectionStartsAt} ~ ${campaign.current.selectionEndsAt}`}</span>
                </div>

                <div className="flex flex-col gap-1">
                  <span className="text-xs tracking-tighter font-bold">{languageTexts.show_text_22}</span>
                  <span className="text-sm tracking-tighter opacity-50">{`${campaign.current.productDeployAt}`}</span>
                </div>

                {campaign?.current?.inspectionSubmitDueDt != null && (
                  <div className="flex flex-col gap-1">
                    <span className="text-xs tracking-tighter font-bold">{languageTexts.show_text_105}</span>
                    <span className="text-sm tracking-tighter opacity-50">
                      {`${campaign.current.inspectionSubmitDueDt}`}
                    </span>
                  </div>
                )}

                {campaign?.current?.inspectionFeedbackDueDt != null && (
                  <div className="flex flex-col gap-1">
                    <span className="text-xs tracking-tighter font-bold">{languageTexts.show_text_110}</span>
                    <span className="text-sm tracking-tighter opacity-50">
                      {`${campaign.current.inspectionFeedbackDueDt}`}
                    </span>
                  </div>
                )}

                <div className="flex flex-col gap-1">
                  <span className="text-xs tracking-tighter font-bold">
                    {campaign?.current?.isSingleDayPosting ? languageTexts.show_text_23_1 : languageTexts.show_text_23}
                  </span>
                  {campaign?.current?.isSingleDayPosting ? (
                    <span className="text-sm tracking-tighter opacity-50">{`${dayjs(campaign.current.postingEndsAt)
                      .subtract(2, 'day')
                      .format('YYYY-MM-DD')}`}</span>
                  ) : (
                    <span className="text-sm tracking-tighter opacity-50">{`${campaign.current.postingStartsAt} ~ ${campaign.current.postingEndsAt}`}</span>
                  )}
                </div>
              </div>
              <div className="flex flex-col min-w-[200px] gap-5">
                <div className="flex flex-col gap-1">
                  <span className="text-xs tracking-tighter font-bold">{languageTexts.show_text_25}</span>
                  <span className="text-sm tracking-tighter opacity-50">{`${campaign.current.deliveryCompanyName}`}</span>
                </div>

                {!isWholesale && (
                  <>
                    <div className="flex flex-col gap-1">
                      <span className="text-xs tracking-tighter font-bold">{languageTexts.show_text_26}</span>
                      <span className="text-sm tracking-tighter opacity-50">{`${campaign.current.hashTags}`}</span>
                    </div>

                    <div className="flex flex-col gap-1">
                      <span className="text-xs tracking-tighter font-bold">{languageTexts.show_text_27}</span>
                      <span className="text-sm tracking-tighter opacity-50">{`${campaign.current.atTag}`}</span>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="flex flex-col gap-1 mt-5 hover:font-bold">
              <div>
                <span
                  className="text-sm font-bold tracking-tighter underline cursor-pointer"
                  onClick={() => {
                    props.showModal({
                      content: () => {
                        return (
                          <CampaignExtendIndex
                            campaignData={campaign.current}
                            onUpdate={async () => {
                              await fetchCampaign();
                              await fetchProduct();
                              await fetchAllApplicants({ refresh: true });
                            }}
                          />
                        );
                      },
                    });
                  }}
                >
                  {languageTexts.show_text_77}
                </span>
              </div>
              <div>
                <span
                  className="text-sm font-bold tracking-tighter underline cursor-pointer"
                  onClick={showCampaignUpdateModal}
                >
                  {languageTexts.show_text_24}
                </span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderCampaignTabs = () => {
    return (
      <RadioButton
        options={tabs}
        tabClassName={'py-3 bg-gray-100'}
        textClassName={'text-black text-base tracking-tighter'}
        selected={selectedTab}
        selectedClassName={'py-3 bg-black'}
        selectedTextClassName="font-bold text-base tracking-tighter"
        selectedTextColor="WHITE"
        onSelect={(filter) => {
          if (selectedTab?.value === filter.value) {
            return;
          }
          navigate({
            pathname: location.pathname,
            search: `?tab=${filter.value}`,
          });
          setSelectedTab(filter);
          switch (filter.value) {
            case TAB_VALUES.POSTINGS:
              fetchPostings({ refresh: true });
              break;
            case TAB_VALUES.APPLICANTS:
              fetchAllApplicants({ refresh: true });
              break;
          }
        }}
      />
    );
  };

  const likedApplicants = useMemo(() => {
    return [
      ...(suggestedAndCommissionIncreasedApplicants ?? []),
      ...(suggestedAndCommissionNotIncreasedApplicants ?? []),
      ...(applicants ?? []),
      ...(unfavorableApplicants ?? []),
    ].filter((app: any) => app.likes != null && app.likes.length > 0);
  }, [
    suggestedAndCommissionNotIncreasedApplicants,
    suggestedAndCommissionIncreasedApplicants,
    applicants,
    unfavorableApplicants,
  ]);

  const renderAppliedInfluencersTabHeader = () => {
    let headerContent = null;

    if (!campaign?.current || !product?.current || !campaign.current?.status) {
      return;
    }

    switch (campaign.current.status) {
      case CampaignStatus.RECRUIT_STARTED: {
        const dDay = dayjs(campaign?.current?.recruitEndsAt).startOf('day').diff(dayjs().startOf('day'), 'day');

        headerContent = {
          title: languageTexts.show_text_103,
          description: `D-${dDay === 0 ? 'DAY' : dDay}`,
          modalButtonText: languageTexts.show_text_104,
          onModalButtonClick: showCampaignUpdateModal,
        };
        break;
      }

      case CampaignStatus.SELECTION_STARTED: {
        if (
          !suggestedAndCommissionNotIncreasedApplicants ||
          !suggestedAndCommissionIncreasedApplicants ||
          !applicants ||
          !unfavorableApplicants ||
          likedApplicants.length <= 0
        ) {
          break;
        }

        headerContent = {
          title: languageTexts.show_text_95,
          description: languageTexts._num_of_person(likedApplicants.length),
          modalButtonText: languageTexts.show_text_96,
          onModalButtonClick: () => {
            selectedRef.current = likedApplicants.map((app: any) => app.userId);
            setSelected(selectedRef.current);

            if (
              handleAdditionalPayment(() => {
                handlePaymentComplete({
                  quantityUpdateRequired: {
                    run: true,
                    quantity: selectedRef.current.length,
                    campaignPaymentKey: updateQuantityCampaignPaymentKey.current,
                  },
                  confirmSelectionRequired: { run: true },
                });
              })
            ) {
              return false;
            }

            showSelectionConfirmModal();
          },
        };
        break;
      }
    }

    return (
      <>
        {headerContent && (
          <div className="py-[80px] flex flex-col items-center">
            <div className="text-[15px]">{headerContent.title}</div>
            <div className="text-[54px] font-bold">{headerContent.description}</div>
            <div
              className="text-[15px] underline cursor-pointer select-none"
              onClick={headerContent.onModalButtonClick}
            >
              {headerContent.modalButtonText}
            </div>
          </div>
        )}
      </>
    );
  };

  const getOrderOptions = () => {
    let defaultOptions: any = [
      {
        name: props.brand.isCategoryBeauty ? languageTexts.sort_order_applied_at : languageTexts.show_text_30,
        column: 'created_at',
        order: 'desc',
        value: 2,
      },
      {
        name: languageTexts.sort_order_commission_desc,
        column: 'commission_amount',
        order: 'desc',
        value: 6,
      },
      {
        name: languageTexts.sort_order_commission_asc,
        column: 'commission_amount',
        order: 'asc',
        value: 7,
      },
      {
        name: languageTexts?.show_text_sort_by_brand_liked_influencers_date,
        column: 'likes_by_brands',
        order: 'desc',
        value: 3,
      },
      // {
      //   name: languageTexts.show_text_31,
      //   column: "ratings",
      //   order: "desc",
      //   value: 2,
      // },
      {
        name: languageTexts.show_text_32,
        column: 'followers',
        order: 'desc',
        value: 4,
      },
      // {
      //   name: languageTexts.show_text_34,
      //   column: "accepted_cnt",
      //   order: "desc",
      //   value: 5,
      // },
    ];

    if (props.brand.isCategoryFashion) {
      defaultOptions = [
        {
          name: languageTexts.show_text_86,
          column: 'connected_at',
          order: 'desc',
          value: 1,
          tooltip: languageTexts._show_text_87(),
          tooltipWidth: 360,
        },
        ...defaultOptions,
        ...[
          {
            name: languageTexts.show_text_33,
            column: 'likes',
            order: 'desc',
            value: 5,
          },
          {
            name: languageTexts.show_text_78,
            column: 'brands_in_ambassador_role_count',
            order: 'desc',
            value: 6,
            tooltip: languageTexts._show_text_80(),
            tooltipWidth: 360,
          },
          {
            name: languageTexts.show_text_79,
            column: 'brands_selected_frequently_count',
            order: 'desc',
            value: 7,
            tooltip: languageTexts._show_text_81(),
            tooltipWidth: 360,
          },
        ],
      ];
    }

    return defaultOptions;
  };

  const openInfluencerProfile = (instagramId:string)=>{
    const url = `https://instagram.com/${instagramId}/reels/`
    if (isMobileDevice()) {
      window.location.href = url
    } else {
      window.open(url, "_blank")
    }
  }

  const renderInfluencerProfile = (user : HiddenInfluencersType, index:number, lenght: number)=>{
    return <><span key={user.userID+'_'+ index} onClick={() => openInfluencerProfile(user?.instagramId)} style={{fontSize: '15px', color: '#000', textDecoration :'underline', cursor: 'pointer'}}>{user?.username}</span>{index !== lenght - 1 ? ',  ' : ''}</>
  }



  const renderHiddenInfluencers = () => {
    if (!selectedTab || selectedTab.value !== 'applicants') return null;
    if(!hiddenInfluencers) return null;
    if (hiddenInfluencers?.brandHiddenUsers?.length == 0 && hiddenInfluencers?.campaignHiddenUsers?.length == 0) return null;
    return (
      <div style={{backgroundColor : '#F3F4F6', borderWidth: '1px', borderColor: '#E8E8E8',display: 'flex', paddingLeft: '20px', flexDirection: 'column', paddingTop: '25px',paddingBottom: '25px', marginTop: '25px'}}>
        <div style={{marginBottom: '10px', fontSize: '15px', color: '#000'}}>{languageTexts.hidden_influencers_text()}</div>
        {hiddenInfluencers?.campaignHiddenUsers?.length > 0 && <div style={{ fontSize: '15px', color: '#000'}}>{languageTexts.only_this_campaign_liked_influencers_text()}{hiddenInfluencers?.campaignHiddenUsers?.map((item, index) => renderInfluencerProfile(item, index, hiddenInfluencers?.campaignHiddenUsers?.length))}</div>}
        {hiddenInfluencers?.brandHiddenUsers?.length > 0 && <div style={{ fontSize: '15px', color: '#000'}}>{languageTexts.saved_influencers_text()}{hiddenInfluencers?.brandHiddenUsers?.map((item, index) => renderInfluencerProfile(item, index, hiddenInfluencers?.brandHiddenUsers?.length))}</div>}
      </div>
    );
  };

  const renderCampaignApplicantsFilters = () => {
    if (!selectedTab || selectedTab.value !== 'applicants') return null;
    if (applicants === undefined) return null;
    if (
      props.brand.isCategoryBeauty &&
      (suggestedAndCommissionIncreasedApplicants === undefined ||
        suggestedAndCommissionNotIncreasedApplicants === undefined)
    )
      return null;
    return (
      <div className="flex flex-col py-6">
        {props.brand.isCategoryFashion && isGlovv() == false ? (
          <div
            className="flex flex-row items-center gap-2 font-bold cursor-pointer"
            onClick={() => {
              props.showOverlays({
                content: () => {
                  return (
                    <OverlayMatchRatingSetting
                      {...props}
                      hasCloseButton={true}
                      shouldShowCautionModal={true}
                      onCompleteSubmit={(styles, categories) => {
                        const selectedCategories = categories.filter((c) => c.rating > 0);
                        const bannedCategories = categories.filter((c) => c.rating < 0);
                        matchSelectedCategoriesRef.current = selectedCategories;
                        setMatchBannedCategories(bannedCategories);

                        fetchAllApplicants({ refresh: true });
                      }}
                    />
                  );
                },
              });
            }}
          >
            <span>{languageTexts.show_text_82}</span>
            <ICON_CHEVRON_RIGHT color="#000" size={20} />
          </div>
        ) : null}

        <div className="mt-3 flex flex-col gap-4">
          <div className="flex flex-row gap-4">
            {/* 찜한 인플루언서 */}
            <Checkbox
              text={languageTexts?.show_text_brand_with_product_liked_influencers}
              checked={filterIsProductUserLiked}
              onClick={() => {
                setSelected([]);
                setFilterIsProductUserLiked(!filterIsProductUserLiked);
              }}
              textClassName={'whitespace-pre'}
            />
            {/* 저장해둔 인플루언서 */}
            <Checkbox
              text={languageTexts?.show_text_brand_liked_influencers}
              checked={filterIsFavorite}
              onClick={() => {
                setSelected([]);
                setFilterLiked(!filterIsFavorite);
              }}
              textClassName={'whitespace-pre'}
            />
            {/* 선정한 적 없는 인플루언서 */}
            <Checkbox
              text={languageTexts?.show_text_brand_never_selected_influencers}
              checked={filterIsNotRented}
              onClick={() => {
                setSelected([]);
                setFilterNotRentedBefore(!filterIsNotRented);
              }}
              textClassName={'whitespace-pre'}
            />
            {/* 선정한 적 있는 인플루언서 */}
            <Checkbox
              text={languageTexts?.show_text_brand_previously_selected_influencers}
              checked={filterIsPreviouslySelected}
              onClick={() => {
                setSelected([]);
                setFilterIsPreviouslySelected(!filterIsPreviouslySelected);
              }}
              textClassName={'whitespace-pre'}
            />
            {/* 신입 인플루언서 */}
            <Checkbox
              text={languageTexts?.show_text_new_influencers}
              checked={filterIsNewInfluencer}
              onClick={() => {
                setSelected([]);
                setFilterIsNewInfluencer(!filterIsNewInfluencer);
              }}
              textClassName={'whitespace-pre'}
            />
          </div>
          {props.brand.isCategoryFashion && isGlovv() == false ? (
            <div className="flex flex-row gap-4">
              {/* 오늘룩 추천모델 */}
              <div className="flex flex-row items-center gap-[6px]">
                <Checkbox
                  text={languageTexts.show_text_76}
                  textClassName={'whitespace-pre'}
                  checked={filterIsSuggested}
                  onClick={() => {
                    setFilterSuggested(!filterIsSuggested);
                  }}
                />
                <div className="px-[8px] py-[4px] text-white bg-[#FF0099] text-[12px] font-bold rounded-full select-none">
                  {languageTexts.show_text_89}
                </div>
              </div>
            </div>
          ) : null}

          <div
            className={clsx([
              'w-full flex items-start gap-[15px]',
              props.preferences.isMobile ? 'flex-col' : 'flex-row',
            ])}
          >
            <div style={{ flex: '0 1 auto' }}>
              <RadioButton
                className={clsx([props.preferences.isMobile ? 'gap-x-[8px] gap-y-[6px]' : 'gap-x-[25px] gap-y-[8px]'])}
                style={{
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  flex: '0 1 auto',
                  flexWrap: 'wrap',
                }}
                buttonContainerStyle={{
                  width: 'auto',
                }}
                dots={true}
                selected={selectedOrder}
                borderless={true}
                singleLine={true}
                options={getOrderOptions()}
                onSelect={(option) => {
                  setSelectedOrder(option);
                }}
              />
            </div>
            {!props.preferences.isMobile &&
            quantity != null &&
            campaign.current.status < CampaignStatus.SELECTION_ENDED ? (
              <div className="text-[#E8E8E8]">{`┃`}</div>
            ) : null}
            {renderProductQuantity()}
          </div>
        </div>
      </div>
    );
  };

  const renderCampaignSuggestedCommissionIncreasedApplicants = () => {
    if (!selectedTab || selectedTab.value !== 'applicants') return null;
    if (suggestedAndCommissionIncreasedApplicants === undefined) return null;
    if (suggestedAndCommissionIncreasedApplicants.length === 0) return null;
    if (applicants === undefined) return null;

    if (campaign.current && campaign.current.status < CampaignStatus.RECRUIT_STARTED) {
      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter text-gray-400">{languageTexts.show_text_36}</span>
        </div>
      );
    }

    if (isSuggestedApplicantsFetching && suggestedAndCommissionIncreasedApplicants === undefined) {
      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter">{`${languageTexts.loading_1}`}</span>
        </div>
      );
    }

    if (!isSuggestedApplicantsFetching && suggestedAndCommissionIncreasedApplicants === undefined) {
      return null;
    }

    if (suggestedAndCommissionIncreasedApplicants && !suggestedAndCommissionIncreasedApplicants.length) {
      let text = languageTexts.show_text_85;

      if (totalApplicantsCount == 0) {
        text = languageTexts._show_text_37(totalApplicantsCount);
      }

      if ((filterIsNotRented || filterIsFavorite || filterIsProductUserLiked || filterIsPreviouslySelected || filterIsNewInfluencer || filterIsSuggested) && totalApplicantsCount == 0) {
        text = languageTexts.show_text_38;
      }

      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter">{`${text}`}</span>
        </div>
      );
    }

    if (suggestedAndCommissionIncreasedApplicants && suggestedAndCommissionIncreasedApplicants.length == 0) {
      let text = languageTexts._show_text_37(suggestedAndCommissionIncreasedApplicants.length);

      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter">{`${text}`}</span>
        </div>
      );
    }
    
    

    return (
      <div className="flex flex-col mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 md:my-6 gap-y-8 gap-x-4">
          {(suggestedAndCommissionIncreasedApplicants || []).map((application, index) => {
            const isSelected = selected && selected.length ? selected.includes(application.userId) : false;

            return (
              <ModelCard
                type={TYPES.CAMPAIGN}
                key={`applicant-model-card-${application.id}-${index}`}
                selected={isSelected}
                isSelectable={getSelectableStatus(campaign.current, product.current)}
                onClick={() => handleSelect(application)}
                application={application}
                isShoes={product.current ? product.current.isShoes : null}
                isUnderwear={product.current ? product.current.isUnderwear : null}
                campaignData={campaign.current}
                
                onProductUserLike={async () => {
                  await handleProductUserLike({
                    productId: application.productId,
                    userId: application.userId,
                    currentLikeId: application.productUserLikes?.[0]?.id || null,
                    applicants: suggestedAndCommissionIncreasedApplicants,
                    setApplicants: setSuggestedAndCommissionIncreasedApplicants,
                    brandToken: props.auth.token
                  })
                }}
                onLike={async () => {
                  try {
                    const response = await API.Like.store({
                      brandToken: props.auth.token,
                      subject: 'Users',
                      subjectId: application.userId,
                    });

                    const applicant = [...suggestedAndCommissionIncreasedApplicants].map((item) =>
                      item.userId == application.userId
                        ? {
                            ...item,
                            ...{
                              likes: response.data.result ? [true] : [],
                            },
                          }
                        : item,
                    );

                    setSuggestedAndCommissionIncreasedApplicants(applicant);
                  } catch (error: any) {
                    props.showModal({ text: error.message });
                  }
                }}
                onReject={(userId: number, result: any) => {
                  const applicant = [...suggestedAndCommissionIncreasedApplicants].map((item) =>
                    item.user.id == userId
                      ? {
                          ...item,
                          ...{
                            reject: result ? false : true,
                          },
                        }
                      : item,
                  );

                  setSuggestedAndCommissionIncreasedApplicants(applicant);
                }}
                nextUser={
                  suggestedAndCommissionIncreasedApplicants[index + 1]
                    ? suggestedAndCommissionIncreasedApplicants[index + 1].user
                    : null
                }
                previousUser={
                  suggestedAndCommissionIncreasedApplicants[index - 1]
                    ? suggestedAndCommissionIncreasedApplicants[index - 1].user
                    : null
                }
                setListData={setSuggestedAndCommissionIncreasedApplicants}
                productId={productId?.current}
              />
            );
          })}
        </div>
      </div>
    );
  };

  const renderCampaignSuggestedCommissionNotIncreasedApplicants = () => {
    if (!selectedTab || selectedTab.value !== 'applicants') return null;
    if (applicants === undefined) return null;

    if (campaign.current && campaign.current.status < CampaignStatus.RECRUIT_STARTED) {
      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter text-gray-400">{languageTexts.show_text_36}</span>
        </div>
      );
    }

    if (isSuggestedApplicantsFetching && suggestedAndCommissionNotIncreasedApplicants === undefined) {
      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter">{`${languageTexts.loading_1}`}</span>
        </div>
      );
    }

    if (!isSuggestedApplicantsFetching && suggestedAndCommissionNotIncreasedApplicants === undefined) {
      return null;
    }

    if (suggestedAndCommissionNotIncreasedApplicants && !suggestedAndCommissionNotIncreasedApplicants.length) {
      let text = languageTexts.show_text_85;

      if (totalApplicantsCount == 0) {
        text = languageTexts._show_text_37(totalApplicantsCount);
      }

      if ((filterIsNotRented || filterIsFavorite || filterIsProductUserLiked || filterIsPreviouslySelected || filterIsNewInfluencer || filterIsSuggested) && totalApplicantsCount == 0) {
        text = languageTexts.show_text_38;
      }

      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter">{`${text}`}</span>
        </div>
      );
    }

    if (suggestedAndCommissionNotIncreasedApplicants && suggestedAndCommissionNotIncreasedApplicants.length == 0) {
      let text = languageTexts._show_text_37(suggestedAndCommissionNotIncreasedApplicants.length);

      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter">{`${text}`}</span>
        </div>
      );
    }

    return (
      <div className="flex flex-col mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 md:my-6 gap-y-8 gap-x-4">
          {(suggestedAndCommissionNotIncreasedApplicants || []).map((application, index) => {
            const isSelected = selected && selected.length ? selected.includes(application.userId) : false;

            return (
              <ModelCard
                type={TYPES.CAMPAIGN}
                key={`applicant-model-card-${application.id}-${index}`}
                selected={isSelected}
                isSelectable={getSelectableStatus(campaign.current, product.current)}
                onClick={() => handleSelect(application)}
                application={application}
                isShoes={product.current ? product.current.isShoes : null}
                isUnderwear={product.current ? product.current.isUnderwear : null}
                campaignData={campaign.current}
                onProductUserLike={async () => {
                  await handleProductUserLike({
                    productId: application.productId,
                    userId: application.userId,
                    currentLikeId: application.productUserLikes?.[0]?.id || null,
                    applicants: suggestedAndCommissionNotIncreasedApplicants,
                    setApplicants: setSuggestedAndCommissionNotIncreasedApplicants,
                    brandToken: props.auth.token
                  })
                }}
                onLike={async () => {
                  try {
                    const response = await API.Like.store({
                      brandToken: props.auth.token,
                      subject: 'Users',
                      subjectId: application.userId,
                    });

                    const applicant = [...suggestedAndCommissionNotIncreasedApplicants].map((item) =>
                      item.userId == application.userId
                        ? {
                            ...item,
                            ...{
                              likes: response.data.result ? [true] : [],
                            },
                          }
                        : item,
                    );

                    setSuggestedAndCommissionNotIncreasedApplicants(applicant);
                  } catch (error: any) {
                    props.showModal({ text: error.message });
                  }
                }}
                onReject={(userId: number, result: any) => {
                  const applicant = [...suggestedAndCommissionNotIncreasedApplicants].map((item) =>
                    item.user.id == userId
                      ? {
                          ...item,
                          ...{
                            reject: result ? false : true,
                          },
                        }
                      : item,
                  );

                  setSuggestedAndCommissionNotIncreasedApplicants(applicant);
                }}
                nextUser={
                  suggestedAndCommissionNotIncreasedApplicants[index + 1]
                    ? suggestedAndCommissionNotIncreasedApplicants[index + 1].user
                    : null
                }
                previousUser={
                  suggestedAndCommissionNotIncreasedApplicants[index - 1]
                    ? suggestedAndCommissionNotIncreasedApplicants[index - 1].user
                    : null
                }
                setListData={setSuggestedAndCommissionNotIncreasedApplicants}
                productId={productId?.current}
              />
            );
          })}
        </div>
      </div>
    );
  };

  const renderCampaignApplicants = () => {
    const renderPaginator = () => {
      return applicantPaginator ? (
        <Paginator
          currentPage={currentModelPage}
          lastPage={applicantPaginator.lastPage}
          onPageChange={(page) => {
            fetchApplicants({
              page: page,
              isSuggested: props.brand.isCategoryBeauty ? false : undefined,
              hasTagAssignmentsSeedableProductCategoryBeauty:
                props.brand.isCategoryBeauty && campaign.current?.status < CampaignStatus.SELECTION_ENDED,
            });
          }}
        />
      ) : null;
    };

    if (!selectedTab || selectedTab.value !== 'applicants') return null;

    // if (applicants === undefined || totalApplicantsCount == undefined) {
    //   return (
    //     <div className="flex flex-row justify-center text-center my-[80px]">
    //       <span className="prose prose-xl text-slate-400">
    //         {languageTexts.loading_1}
    //       </span>
    //     </div>
    //   );
    // }

    if (campaign.current && campaign.current.status < CampaignStatus.RECRUIT_STARTED) {
      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter text-gray-400">{languageTexts.show_text_36}</span>
        </div>
      );
    }

    // const isRecruiting = campaign.current && campaign.current.status < 3;

    if (isApplicantsFetching && applicants === undefined) {
      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter">{`${languageTexts.loading_1}`}</span>
        </div>
      );
    }

    if (applicants && !applicants.length) {
      let text = languageTexts.show_text_85;

      if (totalApplicantsCount == 0) {
        text = languageTexts._show_text_37(totalApplicantsCount);
      }

      if ((filterIsNotRented || filterIsFavorite || filterIsProductUserLiked || filterIsPreviouslySelected || filterIsNewInfluencer || filterIsSuggested) && totalApplicantsCount == 0) {
        text = languageTexts.show_text_38;
      }

      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter">{`${text}`}</span>
        </div>
      );
    }

    if (applicants && applicants.length == 0) {
      let text = languageTexts._show_text_37(totalApplicantsCount);

      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter">{`${text}`}</span>
        </div>
      );
    }

    return (
      <div className="flex flex-col mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 md:my-6 gap-y-8 gap-x-4">
          {(applicants || []).map((application, index) => {
            const isSelected = selected && selected.length ? selected.includes(application.userId) : false;

            return (
              <ModelCard
                type={TYPES.CAMPAIGN}
                key={`applicant-model-card-${application.id}-${index}`}
                selected={isSelected}
                isSelectable={getSelectableStatus(campaign.current, product.current)}
                onClick={() => handleSelect(application)}
                application={application}
                isShoes={product.current ? product.current.isShoes : null}
                isUnderwear={product.current ? product.current.isUnderwear : null}
                campaignData={campaign.current}
                onProductUserLike={async () => {
                  await handleProductUserLike({
                    productId: application.productId,
                    userId: application.userId,
                    currentLikeId: application.productUserLikes?.[0]?.id || null,
                    applicants: applicants,
                    setApplicants: setApplicants,
                    brandToken: props.auth.token
                  })
                }}
                onLike={async () => {
                  try {
                    const response = await API.Like.store({
                      brandToken: props.auth.token,
                      subject: 'Users',
                      subjectId: application.userId,
                    });

                    const applicant = [...applicants].map((item) =>
                      item.userId == application.userId
                        ? {
                            ...item,
                            ...{
                              likes: response.data.result ? [true] : [],
                            },
                          }
                        : item,
                    );

                    setApplicants(applicant);
                  } catch (error: any) {
                    props.showModal({ text: error.message });
                  }
                }}
                onReject={(userId: number, result: any) => {
                  const applicant = [...applicants].map((item) =>
                    item.user.id == userId
                      ? {
                          ...item,
                          ...{
                            reject: result ? false : true,
                          },
                        }
                      : item,
                  );

                  setApplicants(applicant);
                }}
                nextUser={applicants[index + 1] ? applicants[index + 1].user : null}
                previousUser={applicants[index - 1] ? applicants[index - 1].user : null}
                setListData={setApplicants}
                productId={productId?.current}
              />
            );
          })}
        </div>
        {renderPaginator()}
      </div>
    );
  };

  const renderCampaignSuggestedCommissionIncreasedApplicantsHeader = () => {
    if (!selectedTab || selectedTab.value !== 'applicants') return null;
    if (suggestedAndCommissionIncreasedApplicants === undefined) return null;
    if (suggestedAndCommissionIncreasedApplicants.length === 0) return null; // ** 이 파트는 1명도 없으면 안보임
    if (applicants === undefined) return null;

    const campaignCommissionAmountText = `${makeMoneyText(
      campaign.current?.commissionAmount,
      10000,
      (moneyText) => languageTexts._price(moneyText, props.settings?.influencerCurrencyText),
      (moneyText) => languageTexts._price_10000(moneyText, props.settings?.influencerCurrencyText),
    )}`;

    return (
      <>
        <div className="mt-[50px] flex flex-col gap-2">
          <div className="font-bold text-2xl tracking-tighter">{`${languageTexts.show_text_109} (${suggestedAndCommissionIncreasedApplicants.length})`}</div>
          <div className="text-base tracking-tighter">{languageTexts._show_text_110(campaignCommissionAmountText)}</div>
        </div>
      </>
    );
  };

  const renderCampaignSuggestedCommissionNotIncreasedApplicantsHeader = () => {
    if (!selectedTab || selectedTab.value !== 'applicants') return null;
    if (suggestedAndCommissionNotIncreasedApplicants === undefined) return null;
    if (applicants === undefined) return null;

    return (
      <>
        <div className="mt-[50px] flex flex-col gap-2">
          <div className="font-bold text-2xl tracking-tighter">{`${languageTexts.show_text_90} (${suggestedAndCommissionNotIncreasedApplicants.length})`}</div>
          <div className="text-base tracking-tighter">{languageTexts.show_text_91}</div>
        </div>
      </>
    );
  };

  const renderCampaignApplicantsHeader = () => {
    if (!selectedTab || selectedTab.value !== 'applicants') return null;
    if (suggestedAndCommissionNotIncreasedApplicants === undefined || applicants === undefined) return null;

    return (
      <>
        <div className="h-[1px] my-[50px] bg-[#E8E8E8]">{/* ----------------------------------- */}</div>
        <div className="flex flex-col gap-2">
          <div className="font-bold text-2xl tracking-tighter">{`${languageTexts.show_text_92} (${applicantsCount})`}</div>
          <div className="text-base text-[#FF0000] tracking-tighter">{languageTexts.normal_influencers_desc()}</div>
        </div>
      </>
    );
  };

  const renderCampaignUnfavorableApplicantsHeader = () => {
    if (!selectedTab || selectedTab.value !== 'applicants') return null;

    if (unfavorableApplicants === undefined) return null;
    if (matchBannedCategories.length === 0) return null;

    return (
      <>
        <div className="h-[1px] my-[50px] bg-[#E8E8E8]">{/* ----------------------------------- */}</div>
        <div className="flex flex-col gap-2">
          <div className="font-bold text-2xl tracking-tighter">{languageTexts.show_text_83}</div>
          <div className="text-base tracking-tighter">
            {languageTexts._show_text_84(
              matchBannedCategories
                .map((category) => {
                  switch (currentLocale) {
                    case LOCALES.KO:
                      return category.nameKo;
                    case LOCALES.JA:
                      return category.nameJa;
                    default:
                      return category.name;
                      break;
                  }
                })
                .join(', '),
            )}
          </div>
        </div>
      </>
    );
  };

  const renderCampaignUnfavorableApplicants = () => {
    if (!selectedTab || selectedTab.value !== 'applicants') return null;

    if (matchBannedCategories.length === 0) return null;

    const renderPaginator = () => {
      return unfavorableApplicantPaginator ? (
        <Paginator
          currentPage={currentUnfavorableModelPage}
          lastPage={unfavorableApplicantPaginator.lastPage}
          onPageChange={(page) => {
            fetchUnfavorableApplicants({
              page: page,
              hasTagAssignmentsSeedableProductCategoryBeauty:
                props.brand.isCategoryBeauty && campaign.current?.status < CampaignStatus.SELECTION_ENDED,
            });
          }}
        />
      ) : null;
    };

    if (!selectedTab || selectedTab.value !== 'applicants') return null;

    // if (applicants === undefined || totalApplicantsCount == undefined) {
    //   return (
    //     <div className="flex flex-row justify-center text-center my-[80px]">
    //       <span className="prose prose-xl text-slate-400">
    //         {languageTexts.loading_1}
    //       </span>
    //     </div>
    //   );
    // }

    if (campaign.current && campaign.current.status < CampaignStatus.RECRUIT_STARTED) {
      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter text-gray-400">{languageTexts.show_text_36}</span>
        </div>
      );
    }

    // const isRecruiting = campaign.current && campaign.current.status < 3;

    if (isUnfavorableApplicantsFetching && unfavorableApplicants === undefined) {
      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter">{`${languageTexts.loading_1}`}</span>
        </div>
      );
    }

    if (unfavorableApplicants && !unfavorableApplicants.length) {
      let text = languageTexts.show_text_85;

      if (totalApplicantsCount == 0) {
        text = languageTexts._show_text_37(totalApplicantsCount);
      }

      if ((filterIsNotRented || filterIsFavorite || filterIsProductUserLiked || filterIsPreviouslySelected || filterIsNewInfluencer || filterIsSuggested) && totalApplicantsCount == 0) {
        text = languageTexts.show_text_38;
      }

      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter">{`${text}`}</span>
        </div>
      );
    }

    if (unfavorableApplicants && unfavorableApplicants.length == 0) {
      let text = languageTexts._show_text_37(totalApplicantsCount);

      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter">{`${text}`}</span>
        </div>
      );
    }

    return (
      <div className="flex flex-col mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 md:my-6 gap-y-8 gap-x-4">
          {(unfavorableApplicants || []).map((application, index) => {
            const isSelected = selected && selected.length ? selected.includes(application.userId) : false;

            return (
              <ModelCard
                type={TYPES.CAMPAIGN}
                key={`applicant-model-card-${application.id}-${index}`}
                selected={isSelected}
                isSelectable={getSelectableStatus(campaign.current, product.current)}
                onClick={() => handleSelect(application)}
                application={application}
                isShoes={product.current ? product.current.isShoes : null}
                isUnderwear={product.current ? product.current.isUnderwear : null}
                campaignData={campaign.current}
                onProductUserLike={async () => {
                  await handleProductUserLike({
                    productId: application.productId,
                    userId: application.userId,
                    currentLikeId: application.productUserLikes?.[0]?.id || null,
                    applicants: unfavorableApplicants,
                    setApplicants: setUnfavorableApplicants,
                    brandToken: props.auth.token
                  })
                }}
                onLike={async () => {
                  try {
                    const response = await API.Like.store({
                      brandToken: props.auth.token,
                      subject: 'Users',
                      subjectId: application.userId,
                    });

                    const applicant = [...unfavorableApplicants].map((item) =>
                      item.userId == application.userId
                        ? {
                            ...item,
                            ...{
                              likes: response.data.result ? [true] : [],
                            },
                          }
                        : item,
                    );

                    setUnfavorableApplicants(applicant);
                  } catch (error: any) {
                    props.showModal({ text: error.message });
                  }
                }}
                onReject={(userId: number, result: any) => {
                  const applicant = [...unfavorableApplicants].map((item) =>
                    item.user.id == userId
                      ? {
                          ...item,
                          ...{
                            reject: result ? false : true,
                          },
                        }
                      : item,
                  );

                  setUnfavorableApplicants(applicant);
                }}
                nextUser={unfavorableApplicants[index + 1] ? unfavorableApplicants[index + 1].user : null}
                previousUser={unfavorableApplicants[index - 1] ? unfavorableApplicants[index - 1].user : null}
                setListData={setUnfavorableApplicants}
                productId={productId?.current}
              />
            );
          })}
        </div>
        {renderPaginator()}
      </div>
    );
  };

  const renderCampaignPostings = () => {
    const renderPaginator = () => {
      return postingPaginator ? (
        <Paginator
          currentPage={currentPostingPage}
          lastPage={postingPaginator.lastPage}
          onPageChange={(page) => {
            fetchPostings({ page: page });
          }}
        />
      ) : null;
    };

    if (!selectedTab || selectedTab.value !== 'postings') return null;

    if (postings === undefined || totalPostingsCount.current === undefined) {
      return (
        <div className="flex flex-row justify-center text-center my-[80px]">
          <span className="prose prose-xl text-slate-400">{languageTexts.loading_1}</span>
        </div>
      );
    }

    if (product.current && !product.current.selectedAt) {
      return (
        <div className="flex flex-col gap-1 justify-center text-center my-[80px]">
          <span className="font-bold text-sm tracking-tighter text-gray-400">{languageTexts.show_text_39}</span>
        </div>
      );
    }

    return (
      <div className="flex flex-col mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 my-6 gap-y-8 gap-x-4">
          {postings.map((posting) => {
            return (
              <PostingCard
                key={`posting-${posting.id}`}
                posting={posting}
                showFeedbacks={false}
                isShoes={product.current ? product.current.isShoes : null}
                isUnderwear={product.current ? product.current.isUnderwear : null}
                onUpdate={(posting?: any) => {
                  const postingsCopy = [...postings].map((item) => (item.id === posting.id ? posting : item));

                  setPostings(postingsCopy);
                }}
                onLike={(userId: number, result: any) => {
                  const postingsCopy = [...postings].map((item) =>
                    item.userId == userId
                      ? {
                          ...item,
                          ...{
                            likes: result ? [true] : [],
                          },
                        }
                      : item,
                  );

                  setPostings(postingsCopy);
                }}
                onSearch={(params: any) => {
                  navigate(ROUTES.POSTING_INDEX.PATH, {
                    state: {
                      ...params,
                    },
                  });
                }}
              />
            );
          })}
        </div>
        {renderPaginator()}
      </div>
    );
  };

  const renderBottomGradient = () => {
    return <BottomGradient />;
  };

  const renderSelectedApplicantsIndicator = () => {
    if (!product.current) return null;

    return (
      <div className="flex flex-row items-center mx-6">
        <span className="font-bold text-xl tracking-tighter">{`${selected ? selected.length : 0} / ${
          product.current.qty
        }`}</span>
      </div>
    );
  };

  const showAdditionalPaymentRequiredModal = (params: {
    currentProductQuantity: number;
    targetProductQuantity: number;
    commissionIncreasedApplicants?: any[];
    onSuccess?: () => void;
  }) => {
    // 파라미터에 commissionIncreasedApplicants 값이 없는 경우
    // updateQuantity 만 진행
    // 파라미터에 commissionIncreasedApplicants 값이 있는 경우
    // updateQuantity 이후 confirmSelection 진행

    const productQtyToAdd = params.targetProductQuantity - params.currentProductQuantity;

    props.showModal({
      hideCloseButton: true,
      content: () => {
        return (
          <div className="p-[30px] pt-[36px] max-w-[360px] flex flex-col bg-white">
            <div className="text-[16px] font-bold">{languageTexts._show_text_97()}</div>
            <div className="mt-[10px] text-[13px] whitespace-pre-wrap">{languageTexts._show_text_99()}</div>
            <div className="mt-[20px]">
              <Button
                className={'py-[12px]'}
                text={languageTexts.confirm}
                textClassName={'flex justify-center text-[13px] text-center'}
                textColor={'WHITE'}
                buttonColor={'BLACK'}
                borderColor={'BLACK'}
                onClick={() => {
                  props.closeModal();
                  showAdditionalPaymentSummary({
                    additionalProductQuantity: productQtyToAdd,
                    targetProductQuantity: params.targetProductQuantity,
                    commissionIncreasedApplicants: params.commissionIncreasedApplicants,
                    onSuccess: () => params.onSuccess(),
                  });
                }}
              />
            </div>
          </div>
        );
      },
    });
  };

  const showSelectionConfirmModal = () => {
    if (!selectedRef.current.length) {
      props.showModal({ text: languageTexts.show_text_40 });
      return false;
    }

    props.showOverlays({
      className: 'lg:w-[1024px] w-full',
      content: () => {
        return (
          <div className="flex flex-col w-[480px] p-10 bg-white rounded-2xl mx-auto">
            <div className="flex justify-between">
              <div>
                <span className="font-bold text-[26px] tracking-tighter">{languageTexts.show_text_41}</span>
              </div>

              <div
                className="cursor-pointer"
                onClick={() => {
                  props.closeOverlays();
                }}
              >
                <ICON_CLOSE />
              </div>
            </div>

            <div className="flex flex-col py-[1.875rem]">
              <span className="text-[#FF0000] font-base tracking-tighter">{languageTexts._show_text_42()}</span>
            </div>

            <div className="flex flex-col">
              <Button
                className={'min-w-[200px] flex px-7 py-3 items-center text-center justify-center'}
                justify={'center'}
                text={languageTexts.show_text_43}
                textColor={'WHITE'}
                textClassName="font-bold text-sm tracking-tighter text-center"
                buttonColor={'BLACK'}
                borderColor={'BLACK'}
                onClick={async () => {
                  props.closeOverlays();
                  await confirmSelection();
                }}
              />
            </div>
          </div>
        );
      },
    });
  };

  const confirmSelection = async () => {
    if (isFetching) {
      props.showModal({ text: languageTexts.select_text_3 });
      return false;
    }

    const params = {
      brandToken: props.auth.token,
      campaignId: campaign.current.id,
      productId: product.current.id,
      selected: selectedRef.current,
      campaignPaymentKey: updateQuantityCampaignPaymentKey.current,
    };

    try {
      setIsFetching(true);
      setIsUnfavorableApplicantsFetching(true);
      await API.CampaignApplicants.store(params);
      await fetchCampaign();
      await fetchProduct();
      setSelected([]);

      props.showModal({
        preventClose: true,
        content: () => {
          return (
            <div className="relative flex flex-col bg-white rounded-2xl p-10 pb-[96px] overflow-hidden min-w-[480px]">
              <div className="flex flex-col gap-6 items-center justify-center">
                <div>
                  <img src={`/assets/icons/ic-check-rounded.svg`} />
                </div>
                <div>
                  <span className="text-2xl font-bold tracking-tighter">{languageTexts.select_text_4}</span>
                </div>
                <div>
                  <span className="text-sm tracking-tighter">{languageTexts.select_text_5}</span>
                </div>
              </div>

              <div className="absolute left-0 right-0 bottom-0">
                <Button
                  className={'py-[22.5px]'}
                  text={languageTexts.confirm}
                  textClassName={'text-base font-bold tracking-tight flex justify-center'}
                  textColor={'WHITE'}
                  buttonColor={'BLACK'}
                  borderColor={'BLACK'}
                  onClick={() => {
                    setIsFetching(false);
                    props.closeModal();
                    props.closeOverlays();
                  }}
                />
              </div>
            </div>
          );
        },
      });

      await fetchAllApplicants({ page: currentModelPage });
      setIsFetching(false);
      setIsUnfavorableApplicantsFetching(false);
    } catch (error) {
      setTimeout(() => {
        props.showModal({
          text: error.message,
          confirm: () => {
            setIsFetching(false);
          },
        });
      }, 400);
      setIsFetching(false);
      setTimeout(() => {
        setIsFetching(false);
      }, 400);
    }
  };

  const renderSelectButton = () => {
    let selectableStatus = [];


    if (!campaign.current || !campaign) return null;

    switch (campaign.current.brandBusinessType) {
      case BRAND.BUSINESS_TYPE.NORMAL:
        selectableStatus = [CampaignStatus.SELECTION_STARTED];
        break;

      case BRAND.BUSINESS_TYPE.WHOLESALE:
        selectableStatus = [CampaignStatus.RECRUIT_STARTED, CampaignStatus.SELECTION_STARTED];
        break;
    }

    const canModifyInfluncerMessage =campaign?.current?.status === CampaignStatus.RECRUIT_STARTED || campaign?.current?.status === CampaignStatus.SELECTION_STARTED;
    const parsedUser = ALL_INFLUENCERS.map((_applicant)=>{
      return {
        ..._applicant.user,
        application : _applicant,
      }
    })

    if (campaign.current && !selectableStatus.includes(campaign.current.status)) {
      return false;
    }
    if (!product.current || !product) return null;
    if (product.current.selectedAt) return null;
    if (isFetching) return null;

    return (
      <div className="flex flex-row items-center fixed bottom-0 left-auto right-0 md:left-auto px-5 py-6 form-submit-button z-[1]">
        <div className="relative z-10 ml-auto mr-auto my-3 text-right md:text-left md:my-0 md:ml-auto self-center">
          <span className="font-bold text-sm tracking-tighter">{languageTexts._show_text_45()}</span>
        </div>

        {renderSelectedApplicantsIndicator()}

        <Button
          textColor={'WHITE'}
          className="flex px-3 py-3 items-center justify-center w-[240px] font-bold"
          buttonColor={true ? 'BLACK' : '#919191'}
          borderColor={true ? 'BLACK' : '#919191'}
          text={languageTexts.show_text_41}
          onClick={() => {
            if (!selectedRef.current.length) {
              props.showModal({ text: languageTexts.show_text_40 });
              return false;
            }

            props.showModal({
              content: () => (
                <InfluencerMessageModal
                  campaignData={campaign.current}
                  handleOpenAppealReels={(params: {
                    url: string;
                    type: string;
                    applicationId: number;
                  }) => {
                    window.open(params.url, "_blank");
                  }}
                  type={props.type as "CAMPAIGN" | "AMBASSADOR"}
                  isInfluencersPage={props.isInfluencersPage}
                  canModifyInfluncerMessage={canModifyInfluncerMessage}
                  users={parsedUser}
                  productId={props.productId}
                  title={languageTexts.message_modal_seelct_title}
                  nextStep={() => {
                    if (
                      handleAdditionalPayment(() => {
                        handlePaymentComplete({
                          quantityUpdateRequired: {
                            run: true,
                            quantity: selectedRef.current.length,
                            campaignPaymentKey: updateQuantityCampaignPaymentKey.current,
                          },
                          confirmSelectionRequired: { run: true },
                        });
                      })
                    ) {
                      return false;
                    }
            
                    showSelectionConfirmModal();
                  }}
                />
              ),
            });
            

            // if (
            //   handleAdditionalPayment(() => {
            //     handlePaymentComplete({
            //       quantityUpdateRequired: {
            //         run: true,
            //         quantity: selectedRef.current.length,
            //         campaignPaymentKey: updateQuantityCampaignPaymentKey.current,
            //       },
            //       confirmSelectionRequired: { run: true },
            //     });
            //   })
            // ) {
            //   return false;
            // }

            // showSelectionConfirmModal();
          }}
        />
      </div>
    );
  };

  const renderSpacer = () => {
    return <div className="pb-[100px]"></div>;
  };

  const renderSelectedApplicants = () => {
    if (!campaign?.current) return null;
    if (!product?.current) return null;
    if (!product.current.selectedAt) return null;
    const allAccpetedApplicants = allApplicants.filter((applicant) => applicant.applyAcceptedAt != null);
    if (allAccpetedApplicants.length === 0) return null;

    const hasPrepareCompleted = allAccpetedApplicants.reduce((pre, cur, i, a) => {
      return pre === true && cur.isPrepared != null;
    }, true);

    const makePrepareDtText = (date) => {
      try {
        const now = dayjs().startOf('day');
        const deploy_at = dayjs(date);
        const diff_day = now.diff(deploy_at, 'day');

        let offset_text = languageTexts.show_text_70;

        if (diff_day < 0) {
          offset_text = languageTexts._show_text_71(diff_day, 1);
        }

        if (diff_day > 0) {
          offset_text = languageTexts._show_text_71(diff_day, 2);
        }

        return languageTexts._show_text_72(deploy_at.format(languageTexts.date_format3), offset_text);
      } catch (e) {
        return languageTexts.show_text_73;
      }
    };

    return (
      <div className="flex flex-col animate__animated animate__fadeIn">
        <div className="flex flex-row my-6 relative">
          <span className="tracking-tighter mx-auto">
            <div className="text-center font-bold text-xl">{languageTexts.select_text_5}</div>
            {!hasPrepareCompleted && campaign.current.productDeployAt != null && (
              <div className="mt-1 text-center text-[15px]">{makePrepareDtText(campaign.current.productDeployAt)}</div>
            )}
          </span>
          <span
            className={clsx(
              'text-xs underline ml-auto opacity-50 self-baseline text-end absolute right-0 bottom-0 cursor-pointer',
              { hidden: props.preferences.isMobile },
            )}
            onClick={() => {
              window.open(
                `/api/export/campaign/applicants?brand_token=${props.auth.token}&products=${product.current.id}`,
                '_blank',
              );
            }}
          >
            {languageTexts.show_text_44}
          </span>
        </div>
        <div className="flex flex-col mb-6 gap-5">
          {allAccpetedApplicants.map((seletedApplicant, index) => {
            return (
              <CampaignApplicantItem
                key={`campaign-applicant-${seletedApplicant.id}-${index}`}
                applicant={seletedApplicant}
                isShoes={product.current ? product.current.isShoes : null}
                isUnderwear={product.current ? product.current.isUnderwear : null}
                onUpdate={(updated) => {
                  if (suggestedAndCommissionIncreasedApplicants) {
                    setSuggestedAndCommissionIncreasedApplicants(
                      [...suggestedAndCommissionIncreasedApplicants].map((item) =>
                        item.id == updated.id ? updated : item,
                      ),
                    );
                  }
                  if (suggestedAndCommissionNotIncreasedApplicants) {
                    setSuggestedAndCommissionNotIncreasedApplicants(
                      [...suggestedAndCommissionNotIncreasedApplicants].map((item) =>
                        item.id == updated.id ? updated : item,
                      ),
                    );
                  }
                  if (applicants) {
                    setApplicants([...applicants].map((item) => (item.id == updated.id ? updated : item)));
                  }
                  if (unfavorableApplicants) {
                    setUnfavorableApplicants(
                      [...unfavorableApplicants].map((item) => (item.id == updated.id ? updated : item)),
                    );
                  }
                }}
              />
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      {isFetching && (
        <div
          className="fixed top-0 w-full h-full flex items-center justify-center z-[1]"
          style={{ backgroundColor: 'rgb(148 163 184 / 0.5)' }}
        >
          <LoadingText
            text={'Loading'}
            render={(text) => (
              <div className="w-[180px] rounded-full p-2 text-center text-3xl font-bold text-white select-none">
                {text}
              </div>
            )}
          />
        </div>
      )}

      <div className="flex flex-col">
        <div className="px-5 md:mx-auto md:w-[800px] lg:w-[1024px]">{renderBreadcrumbs()}</div>
        <div className="flex flex-col bg-[#F0F2FA] mb-5">
          <div className="px-5 md:mx-auto md:w-[800px] lg:w-[1024px]">{renderSelectedApplicants()}</div>
        </div>
        <div className="px-5 md:mx-auto md:w-[800px] lg:w-[1024px]">
          {renderCampaignProductHeader()}
          {renderCampaignTabs()}
          {renderAppliedInfluencersTabHeader()}
          {renderHiddenInfluencers()}
          {renderCampaignApplicantsFilters()}
          {renderCampaignSuggestedCommissionIncreasedApplicantsHeader()}
          {renderCampaignSuggestedCommissionIncreasedApplicants()}
          {renderCampaignSuggestedCommissionNotIncreasedApplicantsHeader()}
          {renderCampaignSuggestedCommissionNotIncreasedApplicants()}
          {renderCampaignApplicantsHeader()}
          {renderCampaignApplicants()}
          {renderCampaignUnfavorableApplicantsHeader()}
          {renderCampaignUnfavorableApplicants()}
          {renderCampaignPostings()}
          {renderSelectButton()}
          {renderSpacer()}
          {renderBottomGradient()}
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchProps)(CampaignShow);
